// Array de palabras con sus nombres y slugs
const words = [
  {
    name: "best paint brushes",
    slug: "best-paint-brushes",
  },
  {
    name: "artist paint brushes",
    slug: "artist-paint-brushes",
  },
  {
    name: "professional paint brushes",
    slug: "professional-paint-brushes",
  },
  {
    name: "brushes for painting",
    slug: "brushes-for-painting",
  },
  {
    name: "natural bristle brushes",
    slug: "natural-bristle-brushes",
  },
  {
    name: "synthetic paint brushes",
    slug: "synthetic-paint-brushes",
  },
  {
    name: "watercolor paint brushes",
    slug: "watercolor-paint-brushes",
  },
  {
    name: "acrylic paint brushes",
    slug: "acrylic-paint-brushes",
  },
  {
    name: "oil paint brushes",
    slug: "oil-paint-brushes",
  },
  {
    name: "painting detail brushes",
    slug: "painting-detail-brushes",
  },
  {
    name: "round paint brushes",
    slug: "round-paint-brushes",
  },
  {
    name: "flat paint brushes",
    slug: "flat-paint-brushes",
  },
  {
    name: "angled paint brushes",
    slug: "angled-paint-brushes",
  },
  {
    name: "fan paint brushes",
    slug: "fan-paint-brushes",
  },
  {
    name: "long handle brushes",
    slug: "long-handle-brushes",
  },
  {
    name: "fine detail brushes",
    slug: "fine-detail-brushes",
  },
  {
    name: "short handle brushes",
    slug: "short-handle-brushes",
  },
  {
    name: "paint brushes for professionals",
    slug: "paint-brushes-for-professionals",
  },
  {
    name: "brushes for acrylic painting",
    slug: "brushes-for-acrylic-painting",
  },
  {
    name: "brushes for oil painting",
    slug: "brushes-for-oil-painting",
  },
  {
    name: "brushes for watercolor painting",
    slug: "brushes-for-watercolor-painting",
  },
  {
    name: "premium artist brushes",
    slug: "premium-artist-brushes",
  },
  {
    name: "soft bristle brushes",
    slug: "soft-bristle-brushes",
  },
  {
    name: "painting brushes for beginners",
    slug: "painting-brushes-for-beginners",
  },
  {
    name: "brushes for canvas painting",
    slug: "brushes-for-canvas-painting",
  },
  {
    name: "artist-quality paint brushes",
    slug: "artist-quality-paint-brushes",
  },
  {
    name: "brushes for fine art",
    slug: "brushes-for-fine-art",
  },
  {
    name: "brushes for painting details",
    slug: "brushes-for-painting-details",
  },
  {
    name: "wide paint brushes",
    slug: "wide-paint-brushes",
  },
  {
    name: "specialty paint brushes",
    slug: "specialty-paint-brushes",
  },
  {
    name: "best brushes for artists",
    slug: "best-brushes-for-artists",
  },
  {
    name: "brushes for mural painting",
    slug: "brushes-for-mural-painting",
  },
  {
    name: "brushes for large-scale painting",
    slug: "brushes-for-large-scale-painting",
  },
  {
    name: "professional-grade paint brushes",
    slug: "professional-grade-paint-brushes",
  },
  {
    name: "beginner paint brush sets",
    slug: "beginner-paint-brush-sets",
  },
  {
    name: "best brushes for watercolor",
    slug: "best-brushes-for-watercolor",
  },
  {
    name: "best brushes for acrylics",
    slug: "best-brushes-for-acrylics",
  },
  {
    name: "best brushes for oils",
    slug: "best-brushes-for-oils",
  },
  {
    name: "high-quality painting brushes",
    slug: "high-quality-painting-brushes",
  },
  {
    name: "brushes for precise painting",
    slug: "brushes-for-precise-painting",
  },
  {
    name: "best synthetic paint brushes",
    slug: "best-synthetic-paint-brushes",
  },
  {
    name: "best natural bristle brushes",
    slug: "best-natural-bristle-brushes",
  },
  {
    name: "premium watercolor brushes",
    slug: "premium-watercolor-brushes",
  },
  {
    name: "affordable paint brushes",
    slug: "affordable-paint-brushes",
  },
  {
    name: "paint brush sets",
    slug: "paint-brush-sets",
  },
  {
    name: "painting brushes for students",
    slug: "painting-brushes-for-students",
  },
  {
    name: "brushes for abstract painting",
    slug: "brushes-for-abstract-painting",
  },
  {
    name: "top-rated paint brushes",
    slug: "top-rated-paint-brushes",
  },
  {
    name: "fine art paint brushes",
    slug: "fine-art-paint-brushes",
  },
  {
    name: "wide flat brushes",
    slug: "wide-flat-brushes",
  },
  {
    name: "soft synthetic brushes",
    slug: "soft-synthetic-brushes",
  },
  {
    name: "best round paint brushes",
    slug: "best-round-paint-brushes",
  },
  {
    name: "brushes for textured painting",
    slug: "brushes-for-textured-painting",
  },
  {
    name: "value paint brush sets",
    slug: "value-paint-brush-sets",
  },
  {
    name: "handmade paint brushes",
    slug: "handmade-paint-brushes",
  },
  {
    name: "painting brushes for children",
    slug: "painting-brushes-for-children",
  },
  {
    name: "ergonomic handle paint brushes",
    slug: "ergonomic-handle-paint-brushes",
  },
  {
    name: "brushes for painting edges",
    slug: "brushes-for-painting-edges",
  },
  {
    name: "brushes for glazing techniques",
    slug: "brushes-for-glazing-techniques",
  },
  {
    name: "multi-purpose paint brushes",
    slug: "multi-purpose-paint-brushes",
  },
  {
    name: "eco-friendly paint brushes",
    slug: "eco-friendly-paint-brushes",
  },
  {
    name: "brushes for portrait painting",
    slug: "brushes-for-portrait-painting",
  },
  {
    name: "best fan paint brushes",
    slug: "best-fan-paint-brushes",
  },
  {
    name: "brushes for smooth strokes",
    slug: "brushes-for-smooth-strokes",
  },
  {
    name: "durable paint brushes",
    slug: "durable-paint-brushes",
  },
  {
    name: "high-end artist brushes",
    slug: "high-end-artist-brushes",
  },
  {
    name: "brushes for varnishing paintings",
    slug: "brushes-for-varnishing-paintings",
  },
  {
    name: "best brushes for blending",
    slug: "best-brushes-for-blending",
  },
  {
    name: "brushes for detail work",
    slug: "brushes-for-detail-work",
  },
  {
    name: "best brushes for layering",
    slug: "best-brushes-for-layering",
  },
  {
    name: "large paint brushes for walls",
    slug: "large-paint-brushes-for-walls",
  },
  {
    name: "brushes for impasto techniques",
    slug: "brushes-for-impasto-techniques",
  },
  {
    name: "brushes for art restoration",
    slug: "brushes-for-art-restoration",
  },
  {
    name: "brushes for decorative painting",
    slug: "brushes-for-decorative-painting",
  },
  {
    name: "artist-approved paint brushes",
    slug: "artist-approved-paint-brushes",
  },
  {
    name: "top-quality brushes for painting",
    slug: "top-quality-brushes-for-painting",
  },
  {
    name: "brushes for painting miniatures",
    slug: "brushes-for-painting-miniatures",
  },
  {
    name: "versatile artist paint brushes",
    slug: "versatile-artist-paint-brushes",
  },
  {
    name: "best brushes for beginners",
    slug: "best-brushes-for-beginners",
  },
  {
    name: "best painting brushes for detail",
    slug: "best-painting-brushes-for-detail",
  },
  {
    name: "custom artist paint brushes",
    slug: "custom-artist-paint-brushes",
  },
  {
    name: "brushes for advanced techniques",
    slug: "brushes-for-advanced-techniques",
  },
  {
    name: "precision painting brush sets",
    slug: "precision-painting-brush-sets",
  },
  {
    name: "affordable artist brushes",
    slug: "affordable-artist-brushes",
  },
  {
    name: "best brushes for professionals",
    slug: "best-brushes-for-professionals",
  },
  {
    name: "brushes for traditional art",
    slug: "brushes-for-traditional-art",
  },
  {
    name: "brushes for contemporary art",
    slug: "brushes-for-contemporary-art",
  },
  {
    name: "best brushes for canvas",
    slug: "best-brushes-for-canvas",
  },
  {
    name: "brushes for realistic painting",
    slug: "brushes-for-realistic-painting",
  },
  {
    name: "studio-quality paint brushes",
    slug: "studio-quality-paint-brushes",
  },
  {
    name: "brushes for painting wood",
    slug: "brushes-for-painting-wood",
  },
  {
    name: "high-performance painting brushes",
    slug: "high-performance-painting-brushes",
  },
  {
    name: "brushes for creative painting",
    slug: "brushes-for-creative-painting",
  },
  {
    name: "value artist brush sets",
    slug: "value-artist-brush-sets",
  },
  {
    name: "high-grade brushes for painting",
    slug: "high-grade-brushes-for-painting",
  },
  {
    name: "lightweight paint brushes",
    slug: "lightweight-paint-brushes",
  },
  {
    name: "ergonomic painting brush sets",
    slug: "ergonomic-painting-brush-sets",
  },
  {
    name: "soft grip artist brushes",
    slug: "soft-grip-artist-brushes",
  },
  {
    name: "brushes for layering paint",
    slug: "brushes-for-layering-paint",
  },
  {
    name: "brushes for mixed media",
    slug: "brushes-for-mixed-media",
  },
  {
    name: "best art frames",
    slug: "best-art-frames",
  },
  {
    name: "frames for artwork",
    slug: "frames-for-artwork",
  },
  {
    name: "professional art frames",
    slug: "professional-art-frames",
  },
  {
    name: "custom art frames",
    slug: "custom-art-frames",
  },
  {
    name: "gallery art frames",
    slug: "gallery-art-frames",
  },
  {
    name: "picture frames for art",
    slug: "picture-frames-for-art",
  },
  {
    name: "wooden art frames",
    slug: "wooden-art-frames",
  },
  {
    name: "metal art frames",
    slug: "metal-art-frames",
  },
  {
    name: "modern art frames",
    slug: "modern-art-frames",
  },
  {
    name: "traditional art frames",
    slug: "traditional-art-frames",
  },
  {
    name: "frames for canvas art",
    slug: "frames-for-canvas-art",
  },
  {
    name: "durable art frames",
    slug: "durable-art-frames",
  },
  {
    name: "frames for fine art",
    slug: "frames-for-fine-art",
  },
  {
    name: "decorative art frames",
    slug: "decorative-art-frames",
  },
  {
    name: "affordable art frames",
    slug: "affordable-art-frames",
  },
  {
    name: "lightweight art frames",
    slug: "lightweight-art-frames",
  },
  {
    name: "frames for framed art",
    slug: "frames-for-framed-art",
  },
  {
    name: "wall-mounted art frames",
    slug: "wall-mounted-art-frames",
  },
  {
    name: "frames for large artworks",
    slug: "frames-for-large-artworks",
  },
  {
    name: "custom frames for artwork",
    slug: "custom-frames-for-artwork",
  },
  {
    name: "floating art frames",
    slug: "floating-art-frames",
  },
  {
    name: "professional artwork frames",
    slug: "professional-artwork-frames",
  },
  {
    name: "acrylic art frames",
    slug: "acrylic-art-frames",
  },
  {
    name: "matte finish art frames",
    slug: "matte-finish-art-frames",
  },
  {
    name: "sleek art frames",
    slug: "sleek-art-frames",
  },
  {
    name: "frames for mixed media art",
    slug: "frames-for-mixed-media-art",
  },
  {
    name: "minimalist art frames",
    slug: "minimalist-art-frames",
  },
  {
    name: "best gallery art frames",
    slug: "best-gallery-art-frames",
  },
  {
    name: "frames for watercolor paintings",
    slug: "frames-for-watercolor-paintings",
  },
  {
    name: "frames for oil paintings",
    slug: "frames-for-oil-paintings",
  },
  {
    name: "frames for pastel artworks",
    slug: "frames-for-pastel-artworks",
  },
  {
    name: "custom gallery frames",
    slug: "custom-gallery-frames",
  },
  {
    name: "frames for textured artwork",
    slug: "frames-for-textured-artwork",
  },
  {
    name: "modern gallery frames",
    slug: "modern-gallery-frames",
  },
  {
    name: "frames for contemporary art",
    slug: "frames-for-contemporary-art",
  },
  {
    name: "reliable frames for artwork",
    slug: "reliable-frames-for-artwork",
  },
  {
    name: "black matte art frames",
    slug: "black-matte-art-frames",
  },
  {
    name: "white finish art frames",
    slug: "white-finish-art-frames",
  },
  {
    name: "frames for stretched canvas",
    slug: "frames-for-stretched-canvas",
  },
  {
    name: "frames for delicate artwork",
    slug: "frames-for-delicate-artwork",
  },
  {
    name: "slim profile art frames",
    slug: "slim-profile-art-frames",
  },
  {
    name: "eco-friendly art frames",
    slug: "eco-friendly-art-frames",
  },
  {
    name: "frames for framed paintings",
    slug: "frames-for-framed-paintings",
  },
  {
    name: "sturdy art frames",
    slug: "sturdy-art-frames",
  },
  {
    name: "frames for portrait art",
    slug: "frames-for-portrait-art",
  },
  {
    name: "frames for abstract paintings",
    slug: "frames-for-abstract-paintings",
  },
  {
    name: "frames for oversized artwork",
    slug: "frames-for-oversized-artwork",
  },
  {
    name: "wall display art frames",
    slug: "wall-display-art-frames",
  },
  {
    name: "frames for art displays",
    slug: "frames-for-art-displays",
  },
  {
    name: "frames for small artworks",
    slug: "frames-for-small-artworks",
  },
  {
    name: "frames for exhibition artwork",
    slug: "frames-for-exhibition-artwork",
  },
  {
    name: "affordable wooden art frames",
    slug: "affordable-wooden-art-frames",
  },
  {
    name: "frames for mounted art",
    slug: "frames-for-mounted-art",
  },
  {
    name: "versatile art frames",
    slug: "versatile-art-frames",
  },
  {
    name: "lightweight hanging frames",
    slug: "lightweight-hanging-frames",
  },
  {
    name: "top-rated art frames",
    slug: "top-rated-art-frames",
  },
  {
    name: "frames for fragile artwork",
    slug: "frames-for-fragile-artwork",
  },
  {
    name: "frames for collectible art",
    slug: "frames-for-collectible-art",
  },
  {
    name: "easy-to-hang art frames",
    slug: "easy-to-hang-art-frames",
  },
  {
    name: "frames for large-scale paintings",
    slug: "frames-for-large-scale-paintings",
  },
  {
    name: "frames for art displays",
    slug: "frames-for-art-displays",
  },
  {
    name: "frames for stretched canvas",
    slug: "frames-for-stretched-canvas",
  },
  {
    name: "sturdy gallery art frames",
    slug: "sturdy-gallery-art-frames",
  },
  {
    name: "frames for decorative paintings",
    slug: "frames-for-decorative-paintings",
  },
  {
    name: "frames for modern art",
    slug: "frames-for-modern-art",
  },
  {
    name: "versatile art display frames",
    slug: "versatile-art-display-frames",
  },
  {
    name: "lightweight and durable frames",
    slug: "lightweight-and-durable-frames",
  },
  {
    name: "wall-mounted picture frames",
    slug: "wall-mounted-picture-frames",
  },
  {
    name: "reliable art display frames",
    slug: "reliable-art-display-frames",
  },
  {
    name: "frames for artistic displays",
    slug: "frames-for-artistic-displays",
  },
  {
    name: "affordable gallery art frames",
    slug: "affordable-gallery-art-frames",
  },
  {
    name: "simple frames for artwork",
    slug: "simple-frames-for-artwork",
  },
  {
    name: "frames for mixed media",
    slug: "frames-for-mixed-media",
  },
  {
    name: "wide border art frames",
    slug: "wide-border-art-frames",
  },
  {
    name: "slim border art frames",
    slug: "slim-border-art-frames",
  },
  {
    name: "durable wall art frames",
    slug: "durable-wall-art-frames",
  },
  {
    name: "large-scale art frames",
    slug: "large-scale-art-frames",
  },
  {
    name: "frames for drawing artwork",
    slug: "frames-for-drawing-artwork",
  },
  {
    name: "exhibition art display frames",
    slug: "exhibition-art-display-frames",
  },
  {
    name: "frames for paper art",
    slug: "frames-for-paper-art",
  },
  {
    name: "best wall art frames",
    slug: "best-wall-art-frames",
  },
  {
    name: "sturdy frames for paintings",
    slug: "sturdy-frames-for-paintings",
  },
  {
    name: "frames for canvas prints",
    slug: "frames-for-canvas-prints",
  },
  {
    name: "frames for art posters",
    slug: "frames-for-art-posters",
  },
  {
    name: "wall frames for art",
    slug: "wall-frames-for-art",
  },
  {
    name: "hanging art display frames",
    slug: "hanging-art-display-frames",
  },
  {
    name: "strong frames for artwork",
    slug: "strong-frames-for-artwork",
  },
  {
    name: "wide profile art frames",
    slug: "wide-profile-art-frames",
  },
  {
    name: "frames for large pictures",
    slug: "frames-for-large-pictures",
  },
  {
    name: "frames for artistic work",
    slug: "frames-for-artistic-work",
  },
  {
    name: "frames for gallery walls",
    slug: "frames-for-gallery-walls",
  },
  {
    name: "simple art display frames",
    slug: "simple-art-display-frames",
  },
  {
    name: "top-rated wall frames",
    slug: "top-rated-wall-frames",
  },
  {
    name: "slim profile display frames",
    slug: "slim-profile-display-frames",
  },
  {
    name: "frames for paper prints",
    slug: "frames-for-paper-prints",
  },
  {
    name: "display frames for canvases",
    slug: "display-frames-for-canvases",
  },
  {
    name: "durable frames for galleries",
    slug: "durable-frames-for-galleries",
  },
  {
    name: "floating frames",
    slug: "floating-frames",
  },
  {
    name: "floating frame for canvas",
    slug: "floating-frame-for-canvas",
  },
  {
    name: "floating frame",
    slug: "floating-frame",
  },
  {
    name: "oil paint primer",
    slug: "oil-paint-primer",
  },
  {
    name: "acrylic paint primer",
    slug: "acrylic-paint-primer",
  },
  {
    name: "watercolor primer for painting",
    slug: "watercolor-primer-for-painting",
  },
  {
    name: "canvas primer for acrylics",
    slug: "canvas-primer-for-acrylics",
  },
  {
    name: "best primer for oil painting",
    slug: "best-primer-for-oil-painting",
  },
  {
    name: "primer for acrylic painting",
    slug: "primer-for-acrylic-painting",
  },
  {
    name: "professional oil paint primer",
    slug: "professional-oil-paint-primer",
  },
  {
    name: "primer for canvas painting",
    slug: "primer-for-canvas-painting",
  },
  {
    name: "gesso primer for painting",
    slug: "gesso-primer-for-painting",
  },
  {
    name: "primer for watercolor paper",
    slug: "primer-for-watercolor-paper",
  },
  {
    name: "primer for mixed media",
    slug: "primer-for-mixed-media",
  },
  {
    name: "acrylic gesso primer",
    slug: "acrylic-gesso-primer",
  },
  {
    name: "oil painting canvas primer",
    slug: "oil-painting-canvas-primer",
  },
  {
    name: "smooth finish paint primer",
    slug: "smooth-finish-paint-primer",
  },
  {
    name: "best acrylic paint primer",
    slug: "best-acrylic-paint-primer",
  },
  {
    name: "best oil painting primer",
    slug: "best-oil-painting-primer",
  },
  {
    name: "high-quality painting primer",
    slug: "high-quality-painting-primer",
  },
  {
    name: "multi-purpose paint primer",
    slug: "multi-purpose-paint-primer",
  },
  {
    name: "primer for stretched canvas",
    slug: "primer-for-stretched-canvas",
  },
  {
    name: "primer for textured surfaces",
    slug: "primer-for-textured-surfaces",
  },
  {
    name: "primer for large paintings",
    slug: "primer-for-large-paintings",
  },
  {
    name: "lightweight primer for painting",
    slug: "lightweight-primer-for-painting",
  },
  {
    name: "primer for bold colors",
    slug: "primer-for-bold-colors",
  },
  {
    name: "primer for glass painting",
    slug: "primer-for-glass-painting",
  },
  {
    name: "primer for smooth strokes",
    slug: "primer-for-smooth-strokes",
  },
  {
    name: "primer for professional painting",
    slug: "primer-for-professional-painting",
  },
  {
    name: "heavy-duty paint primer",
    slug: "heavy-duty-paint-primer",
  },
  {
    name: "affordable acrylic paint primer",
    slug: "affordable-acrylic-paint-primer",
  },
  {
    name: "fast-drying oil paint primer",
    slug: "fast-drying-oil-paint-primer",
  },
  {
    name: "primer for wood painting",
    slug: "primer-for-wood-painting",
  },
  {
    name: "primer for metal surfaces",
    slug: "primer-for-metal-surfaces",
  },
  {
    name: "primer for mural painting",
    slug: "primer-for-mural-painting",
  },
  {
    name: "primer for creating textures",
    slug: "primer-for-creating-textures",
  },
  {
    name: "primer for layering acrylics",
    slug: "primer-for-layering-acrylics",
  },
  {
    name: "primer for detailed painting",
    slug: "primer-for-detailed-painting",
  },
  {
    name: "primer for abstract artwork",
    slug: "primer-for-abstract-artwork",
  },
  {
    name: "primer for vibrant colors",
    slug: "primer-for-vibrant-colors",
  },
  {
    name: "primer for artistic techniques",
    slug: "primer-for-artistic-techniques",
  },
  {
    name: "primer for smooth layering",
    slug: "primer-for-smooth-layering",
  },
  {
    name: "primer for art preparation",
    slug: "primer-for-art-preparation",
  },
  {
    name: "durable oil paint primer",
    slug: "durable-oil-paint-primer",
  },
  {
    name: "water-based acrylic primer",
    slug: "water-based-acrylic-primer",
  },
  {
    name: "best primer for mixed media",
    slug: "best-primer-for-mixed-media",
  },
  {
    name: "primer for flexible surfaces",
    slug: "primer-for-flexible-surfaces",
  },
  {
    name: "versatile primer for painting",
    slug: "versatile-primer-for-painting",
  },
  {
    name: "non-toxic paint primer",
    slug: "non-toxic-paint-primer",
  },
  {
    name: "eco-friendly acrylic primer",
    slug: "eco-friendly-acrylic-primer",
  },
  {
    name: "primer for art restoration",
    slug: "primer-for-art-restoration",
  },
  {
    name: "primer for high-opacity painting",
    slug: "primer-for-high-opacity-painting",
  },
  {
    name: "primer for undercoating canvas",
    slug: "primer-for-undercoating-canvas",
  },
  {
    name: "gesso primer for oil painting",
    slug: "gesso-primer-for-oil-painting",
  },
  {
    name: "primer for hard-to-paint surfaces",
    slug: "primer-for-hard-to-paint-surfaces",
  },
  {
    name: "primer for blending layers",
    slug: "primer-for-blending-layers",
  },
  {
    name: "primer for watercolor layering",
    slug: "primer-for-watercolor-layering",
  },
  {
    name: "primer for painting edges",
    slug: "primer-for-painting-edges",
  },
  {
    name: "primer for textured canvas",
    slug: "primer-for-textured-canvas",
  },
  {
    name: "primer for smooth finishes",
    slug: "primer-for-smooth-finishes",
  },
  {
    name: "oil painting surface primer",
    slug: "oil-painting-surface-primer",
  },
  {
    name: "primer for painting boards",
    slug: "primer-for-painting-boards",
  },
  {
    name: "primer for intricate details",
    slug: "primer-for-intricate-details",
  },
  {
    name: "primer for custom painting",
    slug: "primer-for-custom-painting",
  },
  {
    name: "artist-grade acrylic primer",
    slug: "artist-grade-acrylic-primer",
  },
  {
    name: "primer for detailed brushwork",
    slug: "primer-for-detailed-brushwork",
  },
  {
    name: "primer for paper painting",
    slug: "primer-for-paper-painting",
  },
  {
    name: "best multi-purpose painting primer",
    slug: "best-multi-purpose-painting-primer",
  },
  {
    name: "primer for fine art",
    slug: "primer-for-fine-art",
  },
  {
    name: "advanced oil paint primer",
    slug: "advanced-oil-paint-primer",
  },
  {
    name: "primer for even coatings",
    slug: "primer-for-even-coatings",
  },
  {
    name: "primer for color vibrancy",
    slug: "primer-for-color-vibrancy",
  },
  {
    name: "best primer for canvas",
    slug: "best-primer-for-canvas",
  },
  {
    name: "versatile acrylic paint primer",
    slug: "versatile-acrylic-paint-primer",
  },
  {
    name: "best gesso for oil painting",
    slug: "best-gesso-for-oil-painting",
  },
  {
    name: "acrylic painting surface primer",
    slug: "acrylic-painting-surface-primer",
  },
  {
    name: "primer for professional artists",
    slug: "primer-for-professional-artists",
  },
  {
    name: "strong adhesion paint primer",
    slug: "strong-adhesion-paint-primer",
  },
  {
    name: "top-rated oil paint primer",
    slug: "top-rated-oil-paint-primer",
  },
  {
    name: "smooth base painting primer",
    slug: "smooth-base-painting-primer",
  },
  {
    name: "acrylic primer for beginners",
    slug: "acrylic-primer-for-beginners",
  },
  {
    name: "oil painting primer for canvas",
    slug: "oil-painting-primer-for-canvas",
  },
  {
    name: "primer for precise layering",
    slug: "primer-for-precise-layering",
  },
  {
    name: "fast-dry acrylic primer",
    slug: "fast-dry-acrylic-primer",
  },
  {
    name: "professional-grade gesso primer",
    slug: "professional-grade-gesso-primer",
  },
  {
    name: "affordable oil paint primer",
    slug: "affordable-oil-paint-primer",
  },
  {
    name: "primer for multiple surfaces",
    slug: "primer-for-multiple-surfaces",
  },
  {
    name: "primer for vibrant finishes",
    slug: "primer-for-vibrant-finishes",
  },
  {
    name: "long-lasting acrylic primer",
    slug: "long-lasting-acrylic-primer",
  },
  {
    name: "primer for seamless blending",
    slug: "primer-for-seamless-blending",
  },
  {
    name: "primer for textured effects",
    slug: "primer-for-textured-effects",
  },
  {
    name: "oil painting preparation primer",
    slug: "oil-painting-preparation-primer",
  },
  {
    name: "primer for acrylic paint layers",
    slug: "primer-for-acrylic-paint-layers",
  },
  {
    name: "high-performance paint primer",
    slug: "high-performance-paint-primer",
  },
  {
    name: "acrylic primer for art boards",
    slug: "acrylic-primer-for-art-boards",
  },
  {
    name: "primer for enhancing textures",
    slug: "primer-for-enhancing-textures",
  },
  {
    name: "advanced acrylic paint primer",
    slug: "advanced-acrylic-paint-primer",
  },
  {
    name: "primer for watercolor techniques",
    slug: "primer-for-watercolor-techniques",
  },
  {
    name: "primer for heavy coatings",
    slug: "primer-for-heavy-coatings",
  },
  {
    name: "smooth finish oil primer",
    slug: "smooth-finish-oil-primer",
  },
  {
    name: "reliable painting surface primer",
    slug: "reliable-painting-surface-primer",
  },
  {
    name: "best primer for textured art",
    slug: "best-primer-for-textured-art",
  },
  {
    name: "primer for art on canvas",
    slug: "primer-for-art-on-canvas",
  },
  {
    name: "best art markers",
    slug: "best-art-markers",
  },
  {
    name: "professional art markers",
    slug: "professional-art-markers",
  },
  {
    name: "markers for artists",
    slug: "markers-for-artists",
  },
  {
    name: "alcohol-based art markers",
    slug: "alcohol-based-art-markers",
  },
  {
    name: "dual-tip art markers",
    slug: "dual-tip-art-markers",
  },
  {
    name: "water-based art markers",
    slug: "water-based-art-markers",
  },
  {
    name: "permanent markers for art",
    slug: "permanent-markers-for-art",
  },
  {
    name: "markers for fine art",
    slug: "markers-for-fine-art",
  },
  {
    name: "markers for sketching",
    slug: "markers-for-sketching",
  },
  {
    name: "markers for illustrations",
    slug: "markers-for-illustrations",
  },
  {
    name: "best markers for drawing",
    slug: "best-markers-for-drawing",
  },
  {
    name: "high-quality art markers",
    slug: "high-quality-art-markers",
  },
  {
    name: "markers for professional artists",
    slug: "markers-for-professional-artists",
  },
  {
    name: "refillable art markers",
    slug: "refillable-art-markers",
  },
  {
    name: "artist-grade alcohol markers",
    slug: "artist-grade-alcohol-markers",
  },
  {
    name: "markers for graphic design",
    slug: "markers-for-graphic-design",
  },
  {
    name: "markers for coloring books",
    slug: "markers-for-coloring-books",
  },
  {
    name: "markers for mixed media",
    slug: "markers-for-mixed-media",
  },
  {
    name: "brush tip art markers",
    slug: "brush-tip-art-markers",
  },
  {
    name: "fine tip art markers",
    slug: "fine-tip-art-markers",
  },
  {
    name: "best markers for sketching",
    slug: "best-markers-for-sketching",
  },
  {
    name: "art markers for beginners",
    slug: "art-markers-for-beginners",
  },
  {
    name: "best markers for shading",
    slug: "best-markers-for-shading",
  },
  {
    name: "markers for architectural drawings",
    slug: "markers-for-architectural-drawings",
  },
  {
    name: "markers for manga art",
    slug: "markers-for-manga-art",
  },
  {
    name: "smooth-flowing art markers",
    slug: "smooth-flowing-art-markers",
  },
  {
    name: "non-toxic art markers",
    slug: "non-toxic-art-markers",
  },
  {
    name: "fade-resistant art markers",
    slug: "fade-resistant-art-markers",
  },
  {
    name: "markers for layering colors",
    slug: "markers-for-layering-colors",
  },
  {
    name: "versatile dual-tip markers",
    slug: "versatile-dual-tip-markers",
  },
  {
    name: "markers for vibrant colors",
    slug: "markers-for-vibrant-colors",
  },
  {
    name: "affordable art marker sets",
    slug: "affordable-art-marker-sets",
  },
  {
    name: "quick-dry art markers",
    slug: "quick-dry-art-markers",
  },
  {
    name: "long-lasting art markers",
    slug: "long-lasting-art-markers",
  },
  {
    name: "markers for detailed work",
    slug: "markers-for-detailed-work",
  },
  {
    name: "vibrant alcohol-based markers",
    slug: "vibrant-alcohol-based-markers",
  },
  {
    name: "markers for digital artists",
    slug: "markers-for-digital-artists",
  },
  {
    name: "markers for hand lettering",
    slug: "markers-for-hand-lettering",
  },
  {
    name: "markers for calligraphy art",
    slug: "markers-for-calligraphy-art",
  },
  {
    name: "durable art marker sets",
    slug: "durable-art-marker-sets",
  },
  {
    name: "artist-quality permanent markers",
    slug: "artist-quality-permanent-markers",
  },
  {
    name: "markers for bold outlines",
    slug: "markers-for-bold-outlines",
  },
  {
    name: "markers for watercolor effects",
    slug: "markers-for-watercolor-effects",
  },
  {
    name: "fast-drying permanent markers",
    slug: "fast-drying-permanent-markers",
  },
  {
    name: "markers for creative projects",
    slug: "markers-for-creative-projects",
  },
  {
    name: "ergonomic art markers",
    slug: "ergonomic-art-markers",
  },
  {
    name: "easy-to-use art markers",
    slug: "easy-to-use-art-markers",
  },
  {
    name: "markers for intricate designs",
    slug: "markers-for-intricate-designs",
  },
  {
    name: "premium brush tip markers",
    slug: "premium-brush-tip-markers",
  },
  {
    name: "markers for detailed illustrations",
    slug: "markers-for-detailed-illustrations",
  },
  {
    name: "flexible brush markers",
    slug: "flexible-brush-markers",
  },
  {
    name: "markers for abstract art",
    slug: "markers-for-abstract-art",
  },
  {
    name: "versatile sketching markers",
    slug: "versatile-sketching-markers",
  },
  {
    name: "water-resistant permanent markers",
    slug: "water-resistant-permanent-markers",
  },
  {
    name: "markers for advanced techniques",
    slug: "markers-for-advanced-techniques",
  },
  {
    name: "archival-quality art markers",
    slug: "archival-quality-art-markers",
  },
  {
    name: "quick-drying sketch markers",
    slug: "quick-drying-sketch-markers",
  },
  {
    name: "best alcohol-based markers",
    slug: "best-alcohol-based-markers",
  },
  {
    name: "fine detail art markers",
    slug: "fine-detail-art-markers",
  },
  {
    name: "refillable alcohol-based markers",
    slug: "refillable-alcohol-based-markers",
  },
  {
    name: "markers for student artists",
    slug: "markers-for-student-artists",
  },
  {
    name: "wide-tip permanent markers",
    slug: "wide-tip-permanent-markers",
  },
  {
    name: "markers for vibrant sketches",
    slug: "markers-for-vibrant-sketches",
  },
  {
    name: "best markers for mixed media",
    slug: "best-markers-for-mixed-media",
  },
  {
    name: "markers for canvas art",
    slug: "markers-for-canvas-art",
  },
  {
    name: "precision tip art markers",
    slug: "precision-tip-art-markers",
  },
  {
    name: "markers for poster design",
    slug: "markers-for-poster-design",
  },
  {
    name: "markers for color blending",
    slug: "markers-for-color-blending",
  },
  {
    name: "best markers for professionals",
    slug: "best-markers-for-professionals",
  },
  {
    name: "markers for tonal gradients",
    slug: "markers-for-tonal-gradients",
  },
  {
    name: "art markers for kids",
    slug: "art-markers-for-kids",
  },
  {
    name: "bold color art markers",
    slug: "bold-color-art-markers",
  },
  {
    name: "beginner-friendly art markers",
    slug: "beginner-friendly-art-markers",
  },
  {
    name: "affordable permanent markers",
    slug: "affordable-permanent-markers",
  },
  {
    name: "markers for urban sketching",
    slug: "markers-for-urban-sketching",
  },
  {
    name: "easy-to-clean art markers",
    slug: "easy-to-clean-art-markers",
  },
  {
    name: "waterproof markers for painting",
    slug: "waterproof-markers-for-painting",
  },
  {
    name: "markers for creative lettering",
    slug: "markers-for-creative-lettering",
  },
  {
    name: "best markers for beginners",
    slug: "best-markers-for-beginners",
  },
  {
    name: "versatile coloring markers",
    slug: "versatile-coloring-markers",
  },
  {
    name: "vibrant refillable markers",
    slug: "vibrant-refillable-markers",
  },
  {
    name: "markers for fine details",
    slug: "markers-for-fine-details",
  },
  {
    name: "markers for artistic effects",
    slug: "markers-for-artistic-effects",
  },
  {
    name: "durable alcohol-based markers",
    slug: "durable-alcohol-based-markers",
  },
  {
    name: "markers for bold colors",
    slug: "markers-for-bold-colors",
  },
  {
    name: "high-pigment art markers",
    slug: "high-pigment-art-markers",
  },
  {
    name: "markers for detailed coloring",
    slug: "markers-for-detailed-coloring",
  },
  {
    name: "premium dual-tip markers",
    slug: "premium-dual-tip-markers",
  },
  {
    name: "best refillable art markers",
    slug: "best-refillable-art-markers",
  },
  {
    name: "smooth-flowing brush markers",
    slug: "smooth-flowing-brush-markers",
  },
  {
    name: "markers for vibrant designs",
    slug: "markers-for-vibrant-designs",
  },
  {
    name: "affordable art markers online",
    slug: "affordable-art-markers-online",
  },
  {
    name: "markers for technical drawings",
    slug: "markers-for-technical-drawings",
  },
  {
    name: "markers for design students",
    slug: "markers-for-design-students",
  },
  {
    name: "fade-proof permanent markers",
    slug: "fade-proof-permanent-markers",
  },
  {
    name: "markers for creative shading",
    slug: "markers-for-creative-shading",
  },
  {
    name: "ergonomic design art markers",
    slug: "ergonomic-design-art-markers",
  },
  {
    name: "quick-drying coloring markers",
    slug: "quick-drying-coloring-markers",
  },
  {
    name: "markers for precision work",
    slug: "markers-for-precision-work",
  },
  {
    name: "professional dual-tip markers",
    slug: "professional-dual-tip-markers",
  },
  {
    name: "best coloured pencils",
    slug: "best-coloured-pencils",
  },
  {
    name: "artist colour pencils",
    slug: "artist-colour-pencils",
  },
  {
    name: "professional colour pencils",
    slug: "professional-colour-pencils",
  },
  {
    name: "vibrant coloured pencils",
    slug: "vibrant-coloured-pencils",
  },
  {
    name: "oil-based colour pencils",
    slug: "oil-based-colour-pencils",
  },
  {
    name: "watercolour colour pencils",
    slug: "watercolour-colour-pencils",
  },
  {
    name: "affordable colour pencils",
    slug: "affordable-colour-pencils",
  },
  {
    name: "fade-resistant coloured pencils",
    slug: "fade-resistant-coloured-pencils",
  },
  {
    name: "smooth coloured pencils",
    slug: "smooth-coloured-pencils",
  },
  {
    name: "coloured pencils set",
    slug: "coloured-pencils-set",
  },
  {
    name: "colour pencils art",
    slug: "colour-pencils-art",
  },
  {
    name: "high-quality colour pencils",
    slug: "high-quality-colour-pencils",
  },
  {
    name: "artist-grade coloured pencils",
    slug: "artist-grade-coloured-pencils",
  },
  {
    name: "best colour pencils",
    slug: "best-colour-pencils",
  },
  {
    name: "beginner colour pencils",
    slug: "beginner-colour-pencils",
  },
  {
    name: "coloured pencils shading",
    slug: "coloured-pencils-shading",
  },
  {
    name: "soft core pencils",
    slug: "soft-core-pencils",
  },
  {
    name: "colour pencils layering",
    slug: "colour-pencils-layering",
  },
  {
    name: "affordable art pencils",
    slug: "affordable-art-pencils",
  },
  {
    name: "durable coloured pencils",
    slug: "durable-coloured-pencils",
  },
  {
    name: "lightfast coloured pencils",
    slug: "lightfast-coloured-pencils",
  },
  {
    name: "premium coloured pencils",
    slug: "premium-coloured-pencils",
  },
  {
    name: "creative colour pencils",
    slug: "creative-colour-pencils",
  },
  {
    name: "professional-grade pencils",
    slug: "professional-grade-pencils",
  },
  {
    name: "versatile coloured pencils",
    slug: "versatile-coloured-pencils",
  },
  {
    name: "detailed art pencils",
    slug: "detailed-art-pencils",
  },
  {
    name: "best art pencils",
    slug: "best-art-pencils",
  },
  {
    name: "smooth colour pencils",
    slug: "smooth-colour-pencils",
  },
  {
    name: "colour pencil blending",
    slug: "colour-pencil-blending",
  },
  {
    name: "top-rated coloured pencils",
    slug: "top-rated-coloured-pencils",
  },
  {
    name: "coloured pencils sketching",
    slug: "coloured-pencils-sketching",
  },
  {
    name: "fade-proof colour pencils",
    slug: "fade-proof-colour-pencils",
  },
  {
    name: "coloured pencils drawing",
    slug: "coloured-pencils-drawing",
  },
  {
    name: "ergonomic colour pencils",
    slug: "ergonomic-colour-pencils",
  },
  {
    name: "oil colour pencils",
    slug: "oil-colour-pencils",
  },
  {
    name: "vibrant tone pencils",
    slug: "vibrant-tone-pencils",
  },
  {
    name: "high pigment pencils",
    slug: "high-pigment-pencils",
  },
  {
    name: "art pencils layering",
    slug: "art-pencils-layering",
  },
  {
    name: "soft shading pencils",
    slug: "soft-shading-pencils",
  },
  {
    name: "realistic art pencils",
    slug: "realistic-art-pencils",
  },
  {
    name: "colour pencils design",
    slug: "colour-pencils-design",
  },
  {
    name: "quality coloured pencils",
    slug: "quality-coloured-pencils",
  },
  {
    name: "student colour pencils",
    slug: "student-colour-pencils",
  },
  {
    name: "coloured pencils portraits",
    slug: "coloured-pencils-portraits",
  },
  {
    name: "professional art pencils",
    slug: "professional-art-pencils",
  },
  {
    name: "top quality pencils",
    slug: "top-quality-pencils",
  },
  {
    name: "soft touch pencils",
    slug: "soft-touch-pencils",
  },
  {
    name: "colour pencils detail",
    slug: "colour-pencils-detail",
  },
  {
    name: "artistic colour pencils",
    slug: "artistic-colour-pencils",
  },
  {
    name: "premium art pencils",
    slug: "premium-art-pencils",
  },
  {
    name: "best oil-based coloured pencils",
    slug: "best-oil-based-coloured-pencils",
  },
  {
    name: "coloured pencils for shading",
    slug: "coloured-pencils-for-shading",
  },
  {
    name: "coloured pencils for blending",
    slug: "coloured-pencils-for-blending",
  },
  {
    name: "watercolour colour pencil sets",
    slug: "watercolour-colour-pencil-sets",
  },
  {
    name: "oil-based colour pencil sets",
    slug: "oil-based-colour-pencil-sets",
  },
  {
    name: "high-quality coloured pencil sets",
    slug: "high-quality-coloured-pencil-sets",
  },
  {
    name: "best professional coloured pencils",
    slug: "best-professional-coloured-pencils",
  },
  {
    name: "vibrant coloured pencil options",
    slug: "vibrant-coloured-pencil-options",
  },
  {
    name: "coloured pencils for beginners",
    slug: "coloured-pencils-for-beginners",
  },
  {
    name: "artist-grade coloured pencil sets",
    slug: "artist-grade-coloured-pencil-sets",
  },
  {
    name: "affordable colour pencil sets",
    slug: "affordable-colour-pencil-sets",
  },
  {
    name: "smooth blending coloured pencils",
    slug: "smooth-blending-coloured-pencils",
  },
  {
    name: "fade-resistant coloured pencil sets",
    slug: "fade-resistant-coloured-pencil-sets",
  },
  {
    name: "coloured pencils for fine art",
    slug: "coloured-pencils-for-fine-art",
  },
  {
    name: "best beginner colour pencils",
    slug: "best-beginner-colour-pencils",
  },
  {
    name: "vibrant tone coloured pencils",
    slug: "vibrant-tone-coloured-pencils",
  },
  {
    name: "affordable artist colour pencils",
    slug: "affordable-artist-colour-pencils",
  },
  {
    name: "colour pencils for illustration",
    slug: "colour-pencils-for-illustration",
  },
  {
    name: "coloured pencils for realistic art",
    slug: "coloured-pencils-for-realistic-art",
  },
  {
    name: "smooth application coloured pencils",
    slug: "smooth-application-coloured-pencils",
  },
  {
    name: "soft touch colour pencils",
    slug: "soft-touch-colour-pencils",
  },
  {
    name: "professional-grade colour pencil sets",
    slug: "professional-grade-colour-pencil-sets",
  },
  {
    name: "artist recommended coloured pencils",
    slug: "artist-recommended-coloured-pencils",
  },
  {
    name: "coloured pencils for large drawings",
    slug: "coloured-pencils-for-large-drawings",
  },
  {
    name: "versatile coloured pencil sets",
    slug: "versatile-coloured-pencil-sets",
  },
  {
    name: "fade-proof coloured pencil sets",
    slug: "fade-proof-coloured-pencil-sets",
  },
  {
    name: "oil-based artist colour pencils",
    slug: "oil-based-artist-colour-pencils",
  },
  {
    name: "premium artist colour pencils",
    slug: "premium-artist-colour-pencils",
  },
  {
    name: "coloured pencils for adult colouring",
    slug: "coloured-pencils-for-adult-colouring",
  },
  {
    name: "best coloured pencils for blending",
    slug: "best-coloured-pencils-for-blending",
  },
  {
    name: "affordable professional colour pencils",
    slug: "affordable-professional-colour-pencils",
  },
  {
    name: "coloured pencils for tonal gradients",
    slug: "coloured-pencils-for-tonal-gradients",
  },
  {
    name: "professional coloured pencil sets",
    slug: "professional-coloured-pencil-sets",
  },
  {
    name: "high-performance artist colour pencils",
    slug: "high-performance-artist-colour-pencils",
  },
  {
    name: "coloured pencils for layering shades",
    slug: "coloured-pencils-for-layering-shades",
  },
  {
    name: "coloured pencils for sketchbooks",
    slug: "coloured-pencils-for-sketchbooks",
  },
  {
    name: "top-rated artist colour pencils",
    slug: "top-rated-artist-colour-pencils",
  },
  {
    name: "best watercolour colour pencils",
    slug: "best-watercolour-colour-pencils",
  },
  {
    name: "coloured pencils for bold colours",
    slug: "coloured-pencils-for-bold-colours",
  },
  {
    name: "creative artist colour pencils",
    slug: "creative-artist-colour-pencils",
  },
  {
    name: "durable coloured pencil options",
    slug: "durable-coloured-pencil-options",
  },
  {
    name: "artist-quality colour pencil sets",
    slug: "artist-quality-colour-pencil-sets",
  },
  {
    name: "smooth flow coloured pencils",
    slug: "smooth-flow-coloured-pencils",
  },
  {
    name: "colour pencils for soft shading",
    slug: "colour-pencils-for-soft-shading",
  },
  {
    name: "artistic tone colour pencils",
    slug: "artistic-tone-colour-pencils",
  },
  {
    name: "top-quality coloured pencil sets",
    slug: "top-quality-coloured-pencil-sets",
  },
  {
    name: "realistic tone colour pencils",
    slug: "realistic-tone-colour-pencils",
  },
  {
    name: "professional smooth coloured pencils",
    slug: "professional-smooth-coloured-pencils",
  },
  {
    name: "ergonomic coloured pencil sets",
    slug: "ergonomic-coloured-pencil-sets",
  },
  {
    name: "detailed shading colour pencils",
    slug: "detailed-shading-colour-pencils",
  },
  {
    name: "best soft pastels",
    slug: "best-soft-pastels",
  },
  {
    name: "professional soft pastels",
    slug: "professional-soft-pastels",
  },
  {
    name: "artist soft pastels",
    slug: "artist-soft-pastels",
  },
  {
    name: "vibrant pastel colors",
    slug: "vibrant-pastel-colors",
  },
  {
    name: "soft pastels for artists",
    slug: "soft-pastels-for-artists",
  },
  {
    name: "high-quality soft pastels",
    slug: "high-quality-soft-pastels",
  },
  {
    name: "oil-based pastel sets",
    slug: "oil-based-pastel-sets",
  },
  {
    name: "smooth blending pastels",
    slug: "smooth-blending-pastels",
  },
  {
    name: "fade-resistant soft pastels",
    slug: "fade-resistant-soft-pastels",
  },
  {
    name: "pastels for fine art",
    slug: "pastels-for-fine-art",
  },
  {
    name: "pastel sets for beginners",
    slug: "pastel-sets-for-beginners",
  },
  {
    name: "affordable pastel art supplies",
    slug: "affordable-pastel-art-supplies",
  },
  {
    name: "soft pastels for shading",
    slug: "soft-pastels-for-shading",
  },
  {
    name: "pastels for realistic drawings",
    slug: "pastels-for-realistic-drawings",
  },
  {
    name: "professional-grade pastel sets",
    slug: "professional-grade-pastel-sets",
  },
  {
    name: "best pastel art supplies",
    slug: "best-pastel-art-supplies",
  },
  {
    name: "pastels for mixed media",
    slug: "pastels-for-mixed-media",
  },
  {
    name: "soft pastels for layering",
    slug: "soft-pastels-for-layering",
  },
  {
    name: "oil pastels for blending",
    slug: "oil-pastels-for-blending",
  },
  {
    name: "soft pastels for portraits",
    slug: "soft-pastels-for-portraits",
  },
  {
    name: "vibrant tone pastel sets",
    slug: "vibrant-tone-pastel-sets",
  },
  {
    name: "top-rated pastel sets",
    slug: "top-rated-pastel-sets",
  },
  {
    name: "premium soft pastels",
    slug: "premium-soft-pastels",
  },
  {
    name: "pastels for landscape art",
    slug: "pastels-for-landscape-art",
  },
  {
    name: "durable pastel art supplies",
    slug: "durable-pastel-art-supplies",
  },
  {
    name: "soft pastels for sketching",
    slug: "soft-pastels-for-sketching",
  },
  {
    name: "beginner-friendly pastel sets",
    slug: "beginner-friendly-pastel-sets",
  },
  {
    name: "soft pastel sticks",
    slug: "soft-pastel-sticks",
  },
  {
    name: "professional pastel art techniques",
    slug: "professional-pastel-art-techniques",
  },
  {
    name: "oil pastels for vibrant tones",
    slug: "oil-pastels-for-vibrant-tones",
  },
  {
    name: "best pastels for blending",
    slug: "best-pastels-for-blending",
  },
  {
    name: "soft pastels for bold artwork",
    slug: "soft-pastels-for-bold-artwork",
  },
  {
    name: "smooth finish pastel sets",
    slug: "smooth-finish-pastel-sets",
  },
  {
    name: "top-quality pastel art materials",
    slug: "top-quality-pastel-art-materials",
  },
  {
    name: "pastels for canvas art",
    slug: "pastels-for-canvas-art",
  },
  {
    name: "pastels for artistic shading",
    slug: "pastels-for-artistic-shading",
  },
  {
    name: "soft pastels for advanced techniques",
    slug: "soft-pastels-for-advanced-techniques",
  },
  {
    name: "best pastels for tonal gradients",
    slug: "best-pastels-for-tonal-gradients",
  },
  {
    name: "vibrant soft pastels for artists",
    slug: "vibrant-soft-pastels-for-artists",
  },
  {
    name: "soft pastels for large artworks",
    slug: "soft-pastels-for-large-artworks",
  },
  {
    name: "pastels for creative effects",
    slug: "pastels-for-creative-effects",
  },
  {
    name: "artist-grade soft pastels",
    slug: "artist-grade-soft-pastels",
  },
  {
    name: "realistic pastel art supplies",
    slug: "realistic-pastel-art-supplies",
  },
  {
    name: "affordable soft pastels for students",
    slug: "affordable-soft-pastels-for-students",
  },
  {
    name: "smooth application pastel sticks",
    slug: "smooth-application-pastel-sticks",
  },
  {
    name: "soft pastels for intricate details",
    slug: "soft-pastels-for-intricate-details",
  },
  {
    name: "vibrant oil pastel sets",
    slug: "vibrant-oil-pastel-sets",
  },
  {
    name: "professional pastel blending tools",
    slug: "professional-pastel-blending-tools",
  },
  {
    name: "pastels for precise layering",
    slug: "pastels-for-precise-layering",
  },
  {
    name: "top-rated soft pastel sticks",
    slug: "top-rated-soft-pastel-sticks",
  },
  {
    name: "soft pastels for color gradients",
    slug: "soft-pastels-for-color-gradients",
  },
  {
    name: "durable soft pastels for artists",
    slug: "durable-soft-pastels-for-artists",
  },
  {
    name: "oil pastel techniques for beginners",
    slug: "oil-pastel-techniques-for-beginners",
  },
  {
    name: "best soft pastels for beginners",
    slug: "best-soft-pastels-for-beginners",
  },
  {
    name: "premium pastel art supplies",
    slug: "premium-pastel-art-supplies",
  },
  {
    name: "pastels for artistic highlights",
    slug: "pastels-for-artistic-highlights",
  },
  {
    name: "soft pastels for fine details",
    slug: "soft-pastels-for-fine-details",
  },
  {
    name: "soft pastels for modern art",
    slug: "soft-pastels-for-modern-art",
  },
  {
    name: "long-lasting soft pastel colors",
    slug: "long-lasting-soft-pastel-colors",
  },
  {
    name: "best pastel sets for layering",
    slug: "best-pastel-sets-for-layering",
  },
  {
    name: "soft pastel blending techniques",
    slug: "soft-pastel-blending-techniques",
  },
  {
    name: "oil pastels for creative artwork",
    slug: "oil-pastels-for-creative-artwork",
  },
  {
    name: "professional pastel shading supplies",
    slug: "professional-pastel-shading-supplies",
  },
  {
    name: "pastels for bold textures",
    slug: "pastels-for-bold-textures",
  },
  {
    name: "fade-proof pastel art materials",
    slug: "fade-proof-pastel-art-materials",
  },
  {
    name: "soft pastels for abstract designs",
    slug: "soft-pastels-for-abstract-designs",
  },
  {
    name: "top-quality soft pastel sets",
    slug: "top-quality-soft-pastel-sets",
  },
  {
    name: "affordable pastel art tools",
    slug: "affordable-pastel-art-tools",
  },
  {
    name: "versatile pastel sets for artists",
    slug: "versatile-pastel-sets-for-artists",
  },
  {
    name: "soft pastels for advanced blending",
    slug: "soft-pastels-for-advanced-blending",
  },
  {
    name: "vibrant pastel sticks for portraits",
    slug: "vibrant-pastel-sticks-for-portraits",
  },
  {
    name: "beginner pastel techniques for students",
    slug: "beginner-pastel-techniques-for-students",
  },
  {
    name: "smooth blending pastel tools",
    slug: "smooth-blending-pastel-tools",
  },
  {
    name: "realistic shading pastel supplies",
    slug: "realistic-shading-pastel-supplies",
  },
  {
    name: "soft pastels for delicate artwork",
    slug: "soft-pastels-for-delicate-artwork",
  },
  {
    name: "artist-recommended pastel supplies",
    slug: "artist-recommended-pastel-supplies",
  },
  {
    name: "fade-resistant pastel colors",
    slug: "fade-resistant-pastel-colors",
  },
  {
    name: "vibrant pastels for sketching",
    slug: "vibrant-pastels-for-sketching",
  },
  {
    name: "pastels for large-scale art",
    slug: "pastels-for-large-scale-art",
  },
  {
    name: "professional pastel color sets",
    slug: "professional-pastel-color-sets",
  },
  {
    name: "soft pastel tools for layering",
    slug: "soft-pastel-tools-for-layering",
  },
  {
    name: "high-pigment pastel sticks",
    slug: "high-pigment-pastel-sticks",
  },
  {
    name: "soft pastels for creative designs",
    slug: "soft-pastels-for-creative-designs",
  },
  {
    name: "pastels for artistic portraits",
    slug: "pastels-for-artistic-portraits",
  },
  {
    name: "oil pastels for shading effects",
    slug: "oil-pastels-for-shading-effects",
  },
  {
    name: "top-rated pastel tools for artists",
    slug: "top-rated-pastel-tools-for-artists",
  },
  {
    name: "soft pastel techniques for professionals",
    slug: "soft-pastel-techniques-for-professionals",
  },
  {
    name: "smooth finish pastel colors",
    slug: "smooth-finish-pastel-colors",
  },
  {
    name: "versatile pastels for art projects",
    slug: "versatile-pastels-for-art-projects",
  },
  {
    name: "soft pastels for vibrant artwork",
    slug: "soft-pastels-for-vibrant-artwork",
  },
  {
    name: "beginner-friendly pastel art supplies",
    slug: "beginner-friendly-pastel-art-supplies",
  },
  {
    name: "durable pastel colors for artwork",
    slug: "durable-pastel-colors-for-artwork",
  },
  {
    name: "professional pastel techniques for layering",
    slug: "professional-pastel-techniques-for-layering",
  },
  {
    name: "vibrant tone pastels for sketching",
    slug: "vibrant-tone-pastels-for-sketching",
  },
  {
    name: "soft pastels for landscape art",
    slug: "soft-pastels-for-landscape-art",
  },
  {
    name: "fade-proof soft pastel sticks",
    slug: "fade-proof-soft-pastel-sticks",
  },
  {
    name: "artistic pastel sets for drawing",
    slug: "artistic-pastel-sets-for-drawing",
  },
  {
    name: "best pastels for realistic effects",
    slug: "best-pastels-for-realistic-effects",
  },
  {
    name: "soft pastels for smooth blending",
    slug: "soft-pastels-for-smooth-blending",
  },
  {
    name: "premium soft pastels for artists",
    slug: "premium-soft-pastels-for-artists",
  },
  {
    name: "best art crayons",
    slug: "best-art-crayons",
  },
  {
    name: "professional artist crayons",
    slug: "professional-artist-crayons",
  },
  {
    name: "vibrant colouring crayons",
    slug: "vibrant-colouring-crayons",
  },
  {
    name: "crayons for artists",
    slug: "crayons-for-artists",
  },
  {
    name: "high-quality art crayons",
    slug: "high-quality-art-crayons",
  },
  {
    name: "best crayons for beginners",
    slug: "best-crayons-for-beginners",
  },
  {
    name: "crayons for adult colouring",
    slug: "crayons-for-adult-colouring",
  },
  {
    name: "oil-based art crayons",
    slug: "oil-based-art-crayons",
  },
  {
    name: "non-toxic art crayons",
    slug: "non-toxic-art-crayons",
  },
  {
    name: "fade-resistant colouring crayons",
    slug: "fade-resistant-colouring-crayons",
  },
  {
    name: "crayons for fine art",
    slug: "crayons-for-fine-art",
  },
  {
    name: "watercolour art crayons",
    slug: "watercolour-art-crayons",
  },
  {
    name: "professional-grade colouring crayons",
    slug: "professional-grade-colouring-crayons",
  },
  {
    name: "vibrant colour crayons",
    slug: "vibrant-colour-crayons",
  },
  {
    name: "crayons for sketching",
    slug: "crayons-for-sketching",
  },
  {
    name: "artist-quality colouring crayons",
    slug: "artist-quality-colouring-crayons",
  },
  {
    name: "smooth blending crayons",
    slug: "smooth-blending-crayons",
  },
  {
    name: "crayons for mixed media",
    slug: "crayons-for-mixed-media",
  },
  {
    name: "durable art crayons",
    slug: "durable-art-crayons",
  },
  {
    name: "premium artist crayons",
    slug: "premium-artist-crayons",
  },
  {
    name: "affordable art crayon sets",
    slug: "affordable-art-crayon-sets",
  },
  {
    name: "artist-recommended art crayons",
    slug: "artist-recommended-art-crayons",
  },
  {
    name: "crayons for creative projects",
    slug: "crayons-for-creative-projects",
  },
  {
    name: "professional crayons for shading",
    slug: "professional-crayons-for-shading",
  },
  {
    name: "crayons for intricate details",
    slug: "crayons-for-intricate-details",
  },
  {
    name: "crayons for bold colours",
    slug: "crayons-for-bold-colours",
  },
  {
    name: "easy-to-use art crayons",
    slug: "easy-to-use-art-crayons",
  },
  {
    name: "best crayons for shading",
    slug: "best-crayons-for-shading",
  },
  {
    name: "soft touch art crayons",
    slug: "soft-touch-art-crayons",
  },
  {
    name: "oil crayons for layering",
    slug: "oil-crayons-for-layering",
  },
  {
    name: "vibrant oil-based crayons",
    slug: "vibrant-oil-based-crayons",
  },
  {
    name: "fade-proof colouring crayons",
    slug: "fade-proof-colouring-crayons",
  },
  {
    name: "beginner-friendly art crayons",
    slug: "beginner-friendly-art-crayons",
  },
  {
    name: "crayons for advanced techniques",
    slug: "crayons-for-advanced-techniques",
  },
  {
    name: "versatile colouring crayon sets",
    slug: "versatile-colouring-crayon-sets",
  },
  {
    name: "smooth finish art crayons",
    slug: "smooth-finish-art-crayons",
  },
  {
    name: "crayons for fine details",
    slug: "crayons-for-fine-details",
  },
  {
    name: "premium oil-based crayons",
    slug: "premium-oil-based-crayons",
  },
  {
    name: "artistic crayon drawing tools",
    slug: "artistic-crayon-drawing-tools",
  },
  {
    name: "crayons for realistic art",
    slug: "crayons-for-realistic-art",
  },
  {
    name: "best crayons for blending",
    slug: "best-crayons-for-blending",
  },
  {
    name: "crayons for bright colours",
    slug: "crayons-for-bright-colours",
  },
  {
    name: "crayons for detailed artwork",
    slug: "crayons-for-detailed-artwork",
  },
  {
    name: "water-resistant art crayons",
    slug: "water-resistant-art-crayons",
  },
  {
    name: "artist-grade oil crayons",
    slug: "artist-grade-oil-crayons",
  },
  {
    name: "professional crayons for layering",
    slug: "professional-crayons-for-layering",
  },
  {
    name: "non-toxic crayons for kids",
    slug: "non-toxic-crayons-for-kids",
  },
  {
    name: "best crayons for portraits",
    slug: "best-crayons-for-portraits",
  },
  {
    name: "vibrant crayons for landscapes",
    slug: "vibrant-crayons-for-landscapes",
  },
  {
    name: "easy-to-clean art crayons",
    slug: "easy-to-clean-art-crayons",
  },
  {
    name: "durable crayons for sketching",
    slug: "durable-crayons-for-sketching",
  },
  {
    name: "versatile art crayon sets",
    slug: "versatile-art-crayon-sets",
  },
  {
    name: "crayons for bold artwork",
    slug: "crayons-for-bold-artwork",
  },
  {
    name: "high-pigment art crayons",
    slug: "high-pigment-art-crayons",
  },
  {
    name: "fade-resistant crayons for artists",
    slug: "fade-resistant-crayons-for-artists",
  },
  {
    name: "oil crayons for shading",
    slug: "oil-crayons-for-shading",
  },
  {
    name: "crayons for textured surfaces",
    slug: "crayons-for-textured-surfaces",
  },
  {
    name: "smooth-flowing colouring crayons",
    slug: "smooth-flowing-colouring-crayons",
  },
  {
    name: "best crayons for layering",
    slug: "best-crayons-for-layering",
  },
  {
    name: "crayons for professional drawings",
    slug: "crayons-for-professional-drawings",
  },
  {
    name: "affordable artist crayon tools",
    slug: "affordable-artist-crayon-tools",
  },
  {
    name: "crayons for creative shading",
    slug: "crayons-for-creative-shading",
  },
  {
    name: "artist-grade crayon sets",
    slug: "artist-grade-crayon-sets",
  },
  {
    name: "soft crayons for blending",
    slug: "soft-crayons-for-blending",
  },
  {
    name: "crayons for artistic effects",
    slug: "crayons-for-artistic-effects",
  },
  {
    name: "crayons for tonal gradients",
    slug: "crayons-for-tonal-gradients",
  },
  {
    name: "best crayons for vibrant tones",
    slug: "best-crayons-for-vibrant-tones",
  },
  {
    name: "high-performance art crayons",
    slug: "high-performance-art-crayons",
  },
  {
    name: "affordable art colouring crayons",
    slug: "affordable-art-colouring-crayons",
  },
  {
    name: "artistic oil crayon techniques",
    slug: "artistic-oil-crayon-techniques",
  },
  {
    name: "crayons for precise layering",
    slug: "crayons-for-precise-layering",
  },
  {
    name: "best art crayons for shading",
    slug: "best-art-crayons-for-shading",
  },
  {
    name: "top-rated colouring crayons",
    slug: "top-rated-colouring-crayons",
  },
  {
    name: "artist-recommended colouring crayons",
    slug: "artist-recommended-colouring-crayons",
  },
  {
    name: "soft crayon drawing tools",
    slug: "soft-crayon-drawing-tools",
  },
  {
    name: "vibrant tone art crayons",
    slug: "vibrant-tone-art-crayons",
  },
  {
    name: "premium crayons for beginners",
    slug: "premium-crayons-for-beginners",
  },
  {
    name: "artistic crayon drawing sets",
    slug: "artistic-crayon-drawing-sets",
  },
  {
    name: "fade-proof artist crayons",
    slug: "fade-proof-artist-crayons",
  },
  {
    name: "crayons for creative drawing",
    slug: "crayons-for-creative-drawing",
  },
  {
    name: "artist-quality oil crayons",
    slug: "artist-quality-oil-crayons",
  },
  {
    name: "smooth blending crayon sets",
    slug: "smooth-blending-crayon-sets",
  },
  {
    name: "artistic crayons for beginners",
    slug: "artistic-crayons-for-beginners",
  },
  {
    name: "crayons for realistic effects",
    slug: "crayons-for-realistic-effects",
  },
  {
    name: "professional shading crayon tools",
    slug: "professional-shading-crayon-tools",
  },
  {
    name: "soft crayons for detailed artwork",
    slug: "soft-crayons-for-detailed-artwork",
  },
  {
    name: "beginner crayons for sketching",
    slug: "beginner-crayons-for-sketching",
  },
  {
    name: "versatile crayon art techniques",
    slug: "versatile-crayon-art-techniques",
  },
  {
    name: "crayons for large-scale drawings",
    slug: "crayons-for-large-scale-drawings",
  },
  {
    name: "best crayons for creative projects",
    slug: "best-crayons-for-creative-projects",
  },
  {
    name: "oil crayons for bold designs",
    slug: "oil-crayons-for-bold-designs",
  },
  {
    name: "crayons for smooth finishes",
    slug: "crayons-for-smooth-finishes",
  },
  {
    name: "high-pigment oil crayons",
    slug: "high-pigment-oil-crayons",
  },
  {
    name: "artistic crayon techniques for shading",
    slug: "artistic-crayon-techniques-for-shading",
  },
  {
    name: "affordable non-toxic art crayons",
    slug: "affordable-non-toxic-art-crayons",
  },
  {
    name: "professional crayon sets for layering",
    slug: "professional-crayon-sets-for-layering",
  },
  {
    name: "vibrant crayons for professional artists",
    slug: "vibrant-crayons-for-professional-artists",
  },
  {
    name: "smooth application crayon sets",
    slug: "smooth-application-crayon-sets",
  },
  {
    name: "artist-grade crayons for blending",
    slug: "artist-grade-crayons-for-blending",
  },
  {
    name: "best crayons for artistic effects",
    slug: "best-crayons-for-artistic-effects",
  },
  {
    name: "best art easels",
    slug: "best-art-easels",
  },
  {
    name: "professional art easels",
    slug: "professional-art-easels",
  },
  {
    name: "wooden art easels",
    slug: "wooden-art-easels",
  },
  {
    name: "adjustable art easels",
    slug: "adjustable-art-easels",
  },
  {
    name: "tabletop art easels",
    slug: "tabletop-art-easels",
  },
  {
    name: "portable art easels",
    slug: "portable-art-easels",
  },
  {
    name: "studio art easels",
    slug: "studio-art-easels",
  },
  {
    name: "durable art easels",
    slug: "durable-art-easels",
  },
  {
    name: "collapsible art easels",
    slug: "collapsible-art-easels",
  },
  {
    name: "affordable art easels",
    slug: "affordable-art-easels",
  },
  {
    name: "artist-grade art easels",
    slug: "artist-grade-art-easels",
  },
  {
    name: "art easels for beginners",
    slug: "art-easels-for-beginners",
  },
  {
    name: "art easels for professionals",
    slug: "art-easels-for-professionals",
  },
  {
    name: "lightweight art easels",
    slug: "lightweight-art-easels",
  },
  {
    name: "folding art easels",
    slug: "folding-art-easels",
  },
  {
    name: "art easels for canvas",
    slug: "art-easels-for-canvas",
  },
  {
    name: "art easels with storage",
    slug: "art-easels-with-storage",
  },
  {
    name: "high-quality art easels",
    slug: "high-quality-art-easels",
  },
  {
    name: "art easels for painting",
    slug: "art-easels-for-painting",
  },
  {
    name: "art easels for classrooms",
    slug: "art-easels-for-classrooms",
  },
  {
    name: "heavy-duty art easels",
    slug: "heavy-duty-art-easels",
  },
  {
    name: "art easels for sketching",
    slug: "art-easels-for-sketching",
  },
  {
    name: "travel-friendly art easels",
    slug: "travel-friendly-art-easels",
  },
  {
    name: "art easels for workshops",
    slug: "art-easels-for-workshops",
  },
  {
    name: "sturdy art easels",
    slug: "sturdy-art-easels",
  },
  {
    name: "compact art easels",
    slug: "compact-art-easels",
  },
  {
    name: "floor-standing art easels",
    slug: "floor-standing-art-easels",
  },
  {
    name: "premium art easels",
    slug: "premium-art-easels",
  },
  {
    name: "adjustable tabletop easels",
    slug: "adjustable-tabletop-easels",
  },
  {
    name: "portable studio easels",
    slug: "portable-studio-easels",
  },
  {
    name: "art easels for kids",
    slug: "art-easels-for-kids",
  },
  {
    name: "art easels for drawing",
    slug: "art-easels-for-drawing",
  },
  {
    name: "metal art easels",
    slug: "metal-art-easels",
  },
  {
    name: "professional-grade art easels",
    slug: "professional-grade-art-easels",
  },
  {
    name: "large art easels",
    slug: "large-art-easels",
  },
  {
    name: "best tabletop easels",
    slug: "best-tabletop-easels",
  },
  {
    name: "multi-purpose art easels",
    slug: "multi-purpose-art-easels",
  },
  {
    name: "budget-friendly art easels",
    slug: "budget-friendly-art-easels",
  },
  {
    name: "ergonomic art easels",
    slug: "ergonomic-art-easels",
  },
  {
    name: "art easels for exhibits",
    slug: "art-easels-for-exhibits",
  },
  {
    name: "functional art easels",
    slug: "functional-art-easels",
  },
  {
    name: "dual-purpose art easels",
    slug: "dual-purpose-art-easels",
  },
  {
    name: "beginner-friendly art easels",
    slug: "beginner-friendly-art-easels",
  },
  {
    name: "art easels with wheels",
    slug: "art-easels-with-wheels",
  },
  {
    name: "premium tabletop easels",
    slug: "premium-tabletop-easels",
  },
  {
    name: "sturdy tabletop easels",
    slug: "sturdy-tabletop-easels",
  },
  {
    name: "art easels with clamps",
    slug: "art-easels-with-clamps",
  },
  {
    name: "adjustable painting easels",
    slug: "adjustable-painting-easels",
  },
  {
    name: "professional studio easels",
    slug: "professional-studio-easels",
  },
  {
    name: "travel-size art easels",
    slug: "travel-size-art-easels",
  },
  {
    name: "versatile art easels",
    slug: "versatile-art-easels",
  },
  {
    name: "easels for acrylic painting",
    slug: "easels-for-acrylic-painting",
  },
  {
    name: "easels for oil painting",
    slug: "easels-for-oil-painting",
  },
  {
    name: "compact studio easels",
    slug: "compact-studio-easels",
  },
  {
    name: "best portable art easels",
    slug: "best-portable-art-easels",
  },
  {
    name: "art easels with drawers",
    slug: "art-easels-with-drawers",
  },
  {
    name: "classic wooden art easels",
    slug: "classic-wooden-art-easels",
  },
  {
    name: "adjustable metal easels",
    slug: "adjustable-metal-easels",
  },
  {
    name: "best studio easels",
    slug: "best-studio-easels",
  },
  {
    name: "folding tabletop easels",
    slug: "folding-tabletop-easels",
  },
  {
    name: "art easels with tilt",
    slug: "art-easels-with-tilt",
  },
  {
    name: "art easels for murals",
    slug: "art-easels-for-murals",
  },
  {
    name: "portable floor easels",
    slug: "portable-floor-easels",
  },
  {
    name: "stable art easels",
    slug: "stable-art-easels",
  },
  {
    name: "best easels for painting",
    slug: "best-easels-for-painting",
  },
  {
    name: "collapsible studio easels",
    slug: "collapsible-studio-easels",
  },
  {
    name: "durable painting easels",
    slug: "durable-painting-easels",
  },
  {
    name: "affordable studio easels",
    slug: "affordable-studio-easels",
  },
  {
    name: "functional tabletop easels",
    slug: "functional-tabletop-easels",
  },
  {
    name: "heavy-duty studio easels",
    slug: "heavy-duty-studio-easels",
  },
  {
    name: "versatile painting easels",
    slug: "versatile-painting-easels",
  },
  {
    name: "art easels with attachments",
    slug: "art-easels-with-attachments",
  },
  {
    name: "best easels for beginners",
    slug: "best-easels-for-beginners",
  },
  {
    name: "art easels with trays",
    slug: "art-easels-with-trays",
  },
  {
    name: "artist-quality painting easels",
    slug: "artist-quality-painting-easels",
  },
  {
    name: "tabletop easels for painting",
    slug: "tabletop-easels-for-painting",
  },
  {
    name: "professional easels for artists",
    slug: "professional-easels-for-artists",
  },
  {
    name: "art easels for detailed work",
    slug: "art-easels-for-detailed-work",
  },
  {
    name: "art easels with storage drawers",
    slug: "art-easels-with-storage-drawers",
  },
  {
    name: "sturdy easels for sketching",
    slug: "sturdy-easels-for-sketching",
  },
  {
    name: "lightweight portable easels",
    slug: "lightweight-portable-easels",
  },
  {
    name: "large canvas art easels",
    slug: "large-canvas-art-easels",
  },
  {
    name: "adjustable studio easels",
    slug: "adjustable-studio-easels",
  },
  {
    name: "best wooden art easels",
    slug: "best-wooden-art-easels",
  },
  {
    name: "freestanding art easels",
    slug: "freestanding-art-easels",
  },
  {
    name: "art easels for outdoor use",
    slug: "art-easels-for-outdoor-use",
  },
  {
    name: "multi-functional art easels",
    slug: "multi-functional-art-easels",
  },
  {
    name: "best easels for studios",
    slug: "best-easels-for-studios",
  },
  {
    name: "art easels with height adjustment",
    slug: "art-easels-with-height-adjustment",
  },
  {
    name: "high-performance painting easels",
    slug: "high-performance-painting-easels",
  },
  {
    name: "compact and lightweight easels",
    slug: "compact-and-lightweight-easels",
  },
  {
    name: "easels for professional painters",
    slug: "easels-for-professional-painters",
  },
  {
    name: "versatile tabletop painting easels",
    slug: "versatile-tabletop-painting-easels",
  },
  {
    name: "heavy-duty painting easels",
    slug: "heavy-duty-painting-easels",
  },
  {
    name: "adjustable floor-standing easels",
    slug: "adjustable-floor-standing-easels",
  },
  {
    name: "top-rated studio easels",
    slug: "top-rated-studio-easels",
  },
  {
    name: "professional-grade painting easels",
    slug: "professional-grade-painting-easels",
  },
  {
    name: "art easels for advanced techniques",
    slug: "art-easels-for-advanced-techniques",
  },
  {
    name: "portable painting easels with storage",
    slug: "portable-painting-easels-with-storage",
  },
  {
    name: "premium adjustable art easels",
    slug: "premium-adjustable-art-easels",
  },
  {
    name: "best art canvas",
    slug: "best-art-canvas",
  },
  {
    name: "professional art canvas",
    slug: "professional-art-canvas",
  },
  {
    name: "premium canvas boards",
    slug: "premium-canvas-boards",
  },
  {
    name: "high-quality art canvas",
    slug: "high-quality-art-canvas",
  },
  {
    name: "stretched canvas for artists",
    slug: "stretched-canvas-for-artists",
  },
  {
    name: "canvas for oil painting",
    slug: "canvas-for-oil-painting",
  },
  {
    name: "canvas for acrylic painting",
    slug: "canvas-for-acrylic-painting",
  },
  {
    name: "artist-grade art canvas",
    slug: "artist-grade-art-canvas",
  },
  {
    name: "large canvas for painting",
    slug: "large-canvas-for-painting",
  },
  {
    name: "canvas for fine art",
    slug: "canvas-for-fine-art",
  },
  {
    name: "durable art canvas",
    slug: "durable-art-canvas",
  },
  {
    name: "affordable canvas boards",
    slug: "affordable-canvas-boards",
  },
  {
    name: "blank art canvas",
    slug: "blank-art-canvas",
  },
  {
    name: "pre-stretched canvas boards",
    slug: "pre-stretched-canvas-boards",
  },
  {
    name: "best stretched canvas",
    slug: "best-stretched-canvas",
  },
  {
    name: "canvas for mixed media",
    slug: "canvas-for-mixed-media",
  },
  {
    name: "lightweight art canvas",
    slug: "lightweight-art-canvas",
  },
  {
    name: "premium cotton canvas",
    slug: "premium-cotton-canvas",
  },
  {
    name: "studio-grade art canvas",
    slug: "studio-grade-art-canvas",
  },
  {
    name: "pre-primed art canvas",
    slug: "pre-primed-art-canvas",
  },
  {
    name: "canvas for professional artists",
    slug: "canvas-for-professional-artists",
  },
  {
    name: "artist canvas for beginners",
    slug: "artist-canvas-for-beginners",
  },
  {
    name: "art canvas for classrooms",
    slug: "art-canvas-for-classrooms",
  },
  {
    name: "custom-sized art canvas",
    slug: "custom-sized-art-canvas",
  },
  {
    name: "versatile canvas boards",
    slug: "versatile-canvas-boards",
  },
  {
    name: "top-rated art canvas",
    slug: "top-rated-art-canvas",
  },
  {
    name: "textured canvas for painting",
    slug: "textured-canvas-for-painting",
  },
  {
    name: "canvas for advanced techniques",
    slug: "canvas-for-advanced-techniques",
  },
  {
    name: "best canvas for painting",
    slug: "best-canvas-for-painting",
  },
  {
    name: "ready-to-paint canvas boards",
    slug: "ready-to-paint-canvas-boards",
  },
  {
    name: "artist-preferred art canvas",
    slug: "artist-preferred-art-canvas",
  },
  {
    name: "pre-stretched cotton canvas",
    slug: "pre-stretched-cotton-canvas",
  },
  {
    name: "art canvas for sketching",
    slug: "art-canvas-for-sketching",
  },
  {
    name: "best canvas for acrylics",
    slug: "best-canvas-for-acrylics",
  },
  {
    name: "high-performance art canvas",
    slug: "high-performance-art-canvas",
  },
  {
    name: "stretched canvas for fine art",
    slug: "stretched-canvas-for-fine-art",
  },
  {
    name: "durable stretched canvas boards",
    slug: "durable-stretched-canvas-boards",
  },
  {
    name: "artist-quality painting canvas",
    slug: "artist-quality-painting-canvas",
  },
  {
    name: "smooth finish canvas boards",
    slug: "smooth-finish-canvas-boards",
  },
  {
    name: "large blank art canvas",
    slug: "large-blank-art-canvas",
  },
  {
    name: "versatile art canvas boards",
    slug: "versatile-art-canvas-boards",
  },
  {
    name: "affordable stretched canvas",
    slug: "affordable-stretched-canvas",
  },
  {
    name: "professional-grade art canvas",
    slug: "professional-grade-art-canvas",
  },
  {
    name: "studio-quality painting canvas",
    slug: "studio-quality-painting-canvas",
  },
  {
    name: "canvas for large artworks",
    slug: "canvas-for-large-artworks",
  },
  {
    name: "pre-stretched canvas for painting",
    slug: "pre-stretched-canvas-for-painting",
  },
  {
    name: "best blank art canvas",
    slug: "best-blank-art-canvas",
  },
  {
    name: "canvas for abstract art",
    slug: "canvas-for-abstract-art",
  },
  {
    name: "fine art canvas boards",
    slug: "fine-art-canvas-boards",
  },
  {
    name: "lightweight stretched canvas",
    slug: "lightweight-stretched-canvas",
  },
  {
    name: "top-quality art canvas",
    slug: "top-quality-art-canvas",
  },
  {
    name: "pre-stretched canvas panels",
    slug: "pre-stretched-canvas-panels",
  },
  {
    name: "sturdy canvas for painting",
    slug: "sturdy-canvas-for-painting",
  },
  {
    name: "gallery-grade art canvas",
    slug: "gallery-grade-art-canvas",
  },
  {
    name: "canvas for artistic layering",
    slug: "canvas-for-artistic-layering",
  },
  {
    name: "affordable canvas for painting",
    slug: "affordable-canvas-for-painting",
  },
  {
    name: "canvas for tonal gradients",
    slug: "canvas-for-tonal-gradients",
  },
  {
    name: "artist canvas for classrooms",
    slug: "artist-canvas-for-classrooms",
  },
  {
    name: "best canvas for beginners",
    slug: "best-canvas-for-beginners",
  },
  {
    name: "art canvas for layering",
    slug: "art-canvas-for-layering",
  },
  {
    name: "textured art canvas boards",
    slug: "textured-art-canvas-boards",
  },
  {
    name: "pre-stretched artist canvas",
    slug: "pre-stretched-artist-canvas",
  },
  {
    name: "art canvas for large paintings",
    slug: "art-canvas-for-large-paintings",
  },
  {
    name: "professional stretched canvas boards",
    slug: "professional-stretched-canvas-boards",
  },
  {
    name: "durable canvas for oil paints",
    slug: "durable-canvas-for-oil-paints",
  },
  {
    name: "cotton canvas for painting",
    slug: "cotton-canvas-for-painting",
  },
  {
    name: "best canvas for fine art",
    slug: "best-canvas-for-fine-art",
  },
  {
    name: "smooth finish painting canvas",
    slug: "smooth-finish-painting-canvas",
  },
  {
    name: "gallery-wrapped art canvas",
    slug: "gallery-wrapped-art-canvas",
  },
  {
    name: "lightweight canvas for sketching",
    slug: "lightweight-canvas-for-sketching",
  },
  {
    name: "best stretched cotton canvas",
    slug: "best-stretched-cotton-canvas",
  },
  {
    name: "pre-stretched gallery canvas",
    slug: "pre-stretched-gallery-canvas",
  },
  {
    name: "studio-grade canvas boards",
    slug: "studio-grade-canvas-boards",
  },
  {
    name: "sturdy pre-stretched canvas",
    slug: "sturdy-pre-stretched-canvas",
  },
  {
    name: "custom-size art canvas",
    slug: "custom-size-art-canvas",
  },
  {
    name: "ready-to-use art canvas",
    slug: "ready-to-use-art-canvas",
  },
  {
    name: "high-pigment art canvas boards",
    slug: "high-pigment-art-canvas-boards",
  },
  {
    name: "smooth texture art canvas",
    slug: "smooth-texture-art-canvas",
  },
  {
    name: "durable canvas for acrylics",
    slug: "durable-canvas-for-acrylics",
  },
  {
    name: "top-rated cotton canvas",
    slug: "top-rated-cotton-canvas",
  },
  {
    name: "professional canvas for painting",
    slug: "professional-canvas-for-painting",
  },
  {
    name: "gallery-wrapped stretched canvas",
    slug: "gallery-wrapped-stretched-canvas",
  },
  {
    name: "large stretched cotton canvas",
    slug: "large-stretched-cotton-canvas",
  },
  {
    name: "versatile painting canvas boards",
    slug: "versatile-painting-canvas-boards",
  },
  {
    name: "art canvas for advanced techniques",
    slug: "art-canvas-for-advanced-techniques",
  },
  {
    name: "fade-resistant art canvas boards",
    slug: "fade-resistant-art-canvas-boards",
  },
  {
    name: "best canvas for tonal shading",
    slug: "best-canvas-for-tonal-shading",
  },
  {
    name: "lightweight cotton canvas panels",
    slug: "lightweight-cotton-canvas-panels",
  },
  {
    name: "durable gallery-grade canvas",
    slug: "durable-gallery-grade-canvas",
  },
  {
    name: "art canvas for creative layering",
    slug: "art-canvas-for-creative-layering",
  },
  {
    name: "artist-preferred stretched canvas",
    slug: "artist-preferred-stretched-canvas",
  },
  {
    name: "smooth surface art canvas",
    slug: "smooth-surface-art-canvas",
  },
  {
    name: "best canvas for portraits",
    slug: "best-canvas-for-portraits",
  },
  {
    name: "painting canvas for mixed media",
    slug: "painting-canvas-for-mixed-media",
  },
  {
    name: "sturdy gallery-wrapped canvas",
    slug: "sturdy-gallery-wrapped-canvas",
  },
  {
    name: "blank stretched canvas boards",
    slug: "blank-stretched-canvas-boards",
  },
  {
    name: "professional-grade cotton canvas",
    slug: "professional-grade-cotton-canvas",
  },
  {
    name: "large pre-stretched art canvas",
    slug: "large-pre-stretched-art-canvas",
  },
  {
    name: "best canvas for realistic art",
    slug: "best-canvas-for-realistic-art",
  },
  {
    name: "versatile cotton canvas boards",
    slug: "versatile-cotton-canvas-boards",
  },
  {
    name: "best rice paper",
    slug: "best-rice-paper",
  },
  {
    name: "professional rice paper",
    slug: "professional-rice-paper",
  },
  {
    name: "yupo paper for artists",
    slug: "yupo-paper-for-artists",
  },
  {
    name: "pastel paper for drawing",
    slug: "pastel-paper-for-drawing",
  },
  {
    name: "premium canvas paper",
    slug: "premium-canvas-paper",
  },
  {
    name: "rice paper for painting",
    slug: "rice-paper-for-painting",
  },
  {
    name: "best sketchbooks for artists",
    slug: "best-sketchbooks-for-artists",
  },
  {
    name: "tracing paper for drawings",
    slug: "tracing-paper-for-drawings",
  },
  {
    name: "transfer paper for art",
    slug: "transfer-paper-for-art",
  },
  {
    name: "drawing paper for beginners",
    slug: "drawing-paper-for-beginners",
  },
  {
    name: "coloured paper for art",
    slug: "coloured-paper-for-art",
  },
  {
    name: "watercolour paper for artists",
    slug: "watercolour-paper-for-artists",
  },
  {
    name: "printmaking paper for professionals",
    slug: "printmaking-paper-for-professionals",
  },
  {
    name: "japanese paper for painting",
    slug: "japanese-paper-for-painting",
  },
  {
    name: "conservation paper for artists",
    slug: "conservation-paper-for-artists",
  },
  {
    name: "best watercolour paper",
    slug: "best-watercolour-paper",
  },
  {
    name: "durable rice paper",
    slug: "durable-rice-paper",
  },
  {
    name: "professional sketchbooks for artists",
    slug: "professional-sketchbooks-for-artists",
  },
  {
    name: "affordable tracing paper",
    slug: "affordable-tracing-paper",
  },
  {
    name: "premium pastel paper",
    slug: "premium-pastel-paper",
  },
  {
    name: "canvas paper for painting",
    slug: "canvas-paper-for-painting",
  },
  {
    name: "high-quality drawing paper",
    slug: "high-quality-drawing-paper",
  },
  {
    name: "artist-grade watercolour paper",
    slug: "artist-grade-watercolour-paper",
  },
  {
    name: "top-rated sketchbooks",
    slug: "top-rated-sketchbooks",
  },
  {
    name: "versatile transfer paper",
    slug: "versatile-transfer-paper",
  },
  {
    name: "smooth drawing paper",
    slug: "smooth-drawing-paper",
  },
  {
    name: "best pastel paper",
    slug: "best-pastel-paper",
  },
  {
    name: "premium yupo paper",
    slug: "premium-yupo-paper",
  },
  {
    name: "conservation paper for fine art",
    slug: "conservation-paper-for-fine-art",
  },
  {
    name: "fade-resistant watercolour paper",
    slug: "fade-resistant-watercolour-paper",
  },
  {
    name: "yupo paper for mixed media",
    slug: "yupo-paper-for-mixed-media",
  },
  {
    name: "textured pastel paper",
    slug: "textured-pastel-paper",
  },
  {
    name: "affordable drawing paper",
    slug: "affordable-drawing-paper",
  },
  {
    name: "professional-grade watercolour paper",
    slug: "professional-grade-watercolour-paper",
  },
  {
    name: "japanese rice paper",
    slug: "japanese-rice-paper",
  },
  {
    name: "best drawing paper",
    slug: "best-drawing-paper",
  },
  {
    name: "artist-quality canvas paper",
    slug: "artist-quality-canvas-paper",
  },
  {
    name: "tracing paper for detailed work",
    slug: "tracing-paper-for-detailed-work",
  },
  {
    name: "best sketchbooks for painting",
    slug: "best-sketchbooks-for-painting",
  },
  {
    name: "vibrant coloured paper",
    slug: "vibrant-coloured-paper",
  },
  {
    name: "durable printmaking paper",
    slug: "durable-printmaking-paper",
  },
  {
    name: "best paper for sketching",
    slug: "best-paper-for-sketching",
  },
  {
    name: "lightweight canvas paper",
    slug: "lightweight-canvas-paper",
  },
  {
    name: "archival conservation paper",
    slug: "archival-conservation-paper",
  },
  {
    name: "smooth surface tracing paper",
    slug: "smooth-surface-tracing-paper",
  },
  {
    name: "watercolour paper for professionals",
    slug: "watercolour-paper-for-professionals",
  },
  {
    name: "rice paper for calligraphy",
    slug: "rice-paper-for-calligraphy",
  },
  {
    name: "yupo paper for beginners",
    slug: "yupo-paper-for-beginners",
  },
  {
    name: "pastel paper for blending",
    slug: "pastel-paper-for-blending",
  },
  {
    name: "printmaking paper for beginners",
    slug: "printmaking-paper-for-beginners",
  },
  {
    name: "sketchbooks for watercolour painting",
    slug: "sketchbooks-for-watercolour-painting",
  },
  {
    name: "affordable canvas paper",
    slug: "affordable-canvas-paper",
  },
  {
    name: "textured watercolour paper",
    slug: "textured-watercolour-paper",
  },
  {
    name: "best rice paper for art",
    slug: "best-rice-paper-for-art",
  },
  {
    name: "conservation paper for preservation",
    slug: "conservation-paper-for-preservation",
  },
  {
    name: "high-pigment coloured paper",
    slug: "high-pigment-coloured-paper",
  },
  {
    name: "tracing paper for layering",
    slug: "tracing-paper-for-layering",
  },
  {
    name: "professional sketchbooks for painting",
    slug: "professional-sketchbooks-for-painting",
  },
  {
    name: "drawing paper for detailed work",
    slug: "drawing-paper-for-detailed-work",
  },
  {
    name: "premium printmaking paper",
    slug: "premium-printmaking-paper",
  },
  {
    name: "lightweight tracing paper",
    slug: "lightweight-tracing-paper",
  },
  {
    name: "coloured paper for crafts",
    slug: "coloured-paper-for-crafts",
  },
  {
    name: "japanese paper for printmaking",
    slug: "japanese-paper-for-printmaking",
  },
  {
    name: "artist sketchbooks for travel",
    slug: "artist-sketchbooks-for-travel",
  },
  {
    name: "pastel paper for portraits",
    slug: "pastel-paper-for-portraits",
  },
  {
    name: "rice paper for crafts",
    slug: "rice-paper-for-crafts",
  },
  {
    name: "smooth printmaking paper",
    slug: "smooth-printmaking-paper",
  },
  {
    name: "yupo paper for professional artists",
    slug: "yupo-paper-for-professional-artists",
  },
  {
    name: "conservation paper for archival work",
    slug: "conservation-paper-for-archival-work",
  },
  {
    name: "best drawing paper for sketching",
    slug: "best-drawing-paper-for-sketching",
  },
  {
    name: "watercolour paper for mixed media",
    slug: "watercolour-paper-for-mixed-media",
  },
  {
    name: "professional-grade pastel paper",
    slug: "professional-grade-pastel-paper",
  },
  {
    name: "canvas paper for acrylics",
    slug: "canvas-paper-for-acrylics",
  },
  {
    name: "fade-resistant tracing paper",
    slug: "fade-resistant-tracing-paper",
  },
  {
    name: "rice paper for wrapping",
    slug: "rice-paper-for-wrapping",
  },
  {
    name: "top-quality drawing paper",
    slug: "top-quality-drawing-paper",
  },
  {
    name: "smooth watercolour paper",
    slug: "smooth-watercolour-paper",
  },
  {
    name: "best pastel paper for shading",
    slug: "best-pastel-paper-for-shading",
  },
  {
    name: "versatile yupo paper",
    slug: "versatile-yupo-paper",
  },
  {
    name: "japanese paper for watercolour",
    slug: "japanese-paper-for-watercolour",
  },
  {
    name: "textured conservation paper",
    slug: "textured-conservation-paper",
  },
  {
    name: "archival-quality printmaking paper",
    slug: "archival-quality-printmaking-paper",
  },
  {
    name: "affordable sketchbooks for beginners",
    slug: "affordable-sketchbooks-for-beginners",
  },
  {
    name: "transfer paper for detailed artwork",
    slug: "transfer-paper-for-detailed-artwork",
  },
  {
    name: "lightweight drawing paper",
    slug: "lightweight-drawing-paper",
  },
  {
    name: "artist-preferred watercolour paper",
    slug: "artist-preferred-watercolour-paper",
  },
  {
    name: "canvas paper for oil painting",
    slug: "canvas-paper-for-oil-painting",
  },
  {
    name: "tracing paper for professionals",
    slug: "tracing-paper-for-professionals",
  },
  {
    name: "rice paper for delicate work",
    slug: "rice-paper-for-delicate-work",
  },
  {
    name: "smooth surface pastel paper",
    slug: "smooth-surface-pastel-paper",
  },
  {
    name: "yupo paper for advanced techniques",
    slug: "yupo-paper-for-advanced-techniques",
  },
  {
    name: "best conservation paper for art",
    slug: "best-conservation-paper-for-art",
  },
  {
    name: "watercolour sketchbooks for travel",
    slug: "watercolour-sketchbooks-for-travel",
  },
  {
    name: "coloured paper for vibrant art",
    slug: "coloured-paper-for-vibrant-art",
  },
  {
    name: "top-rated pastel paper",
    slug: "top-rated-pastel-paper",
  },
  {
    name: "printmaking paper for high detail",
    slug: "printmaking-paper-for-high-detail",
  },
  {
    name: "best tracing paper for artists",
    slug: "best-tracing-paper-for-artists",
  },
  {
    name: "premium japanese rice paper",
    slug: "premium-japanese-rice-paper",
  },
  {
    name: "artist-grade drawing paper",
    slug: "artist-grade-drawing-paper",
  },
  {
    name: "durable sketchbooks for travel",
    slug: "durable-sketchbooks-for-travel",
  },
  {
    name: "oil painting mediums",
    slug: "oil-painting-mediums",
  },
  {
    name: "acrylic painting mediums",
    slug: "acrylic-painting-mediums",
  },
  {
    name: "watercolour blending mediums",
    slug: "watercolour-blending-mediums",
  },
  {
    name: "best oil mediums",
    slug: "best-oil-mediums",
  },
  {
    name: "glazing mediums for oils",
    slug: "glazing-mediums-for-oils",
  },
  {
    name: "professional acrylic mediums",
    slug: "professional-acrylic-mediums",
  },
  {
    name: "water-mixable oil mediums",
    slug: "water-mixable-oil-mediums",
  },
  {
    name: "acrylic texture mediums",
    slug: "acrylic-texture-mediums",
  },
  {
    name: "oil painting additives",
    slug: "oil-painting-additives",
  },
  {
    name: "artist-grade acrylic mediums",
    slug: "artist-grade-acrylic-mediums",
  },
  {
    name: "slow-drying oil mediums",
    slug: "slow-drying-oil-mediums",
  },
  {
    name: "water-mixable painting mediums",
    slug: "water-mixable-painting-mediums",
  },
  {
    name: "watercolour masking mediums",
    slug: "watercolour-masking-mediums",
  },
  {
    name: "acrylic flow mediums",
    slug: "acrylic-flow-mediums",
  },
  {
    name: "oil thinning mediums",
    slug: "oil-thinning-mediums",
  },
  {
    name: "best acrylic painting medium",
    slug: "best-acrylic-painting-medium",
  },
  {
    name: "water-mixable oil extenders",
    slug: "water-mixable-oil-extenders",
  },
  {
    name: "acrylic painting gloss mediums",
    slug: "acrylic-painting-gloss-mediums",
  },
  {
    name: "matte acrylic mediums",
    slug: "matte-acrylic-mediums",
  },
  {
    name: "professional-grade oil mediums",
    slug: "professional-grade-oil-mediums",
  },
  {
    name: "watercolour texture mediums",
    slug: "watercolour-texture-mediums",
  },
  {
    name: "oil-based painting mediums",
    slug: "oil-based-painting-mediums",
  },
  {
    name: "best watercolour blending medium",
    slug: "best-watercolour-blending-medium",
  },
  {
    name: "acrylic painting gel mediums",
    slug: "acrylic-painting-gel-mediums",
  },
  {
    name: "top-rated oil mediums",
    slug: "top-rated-oil-mediums",
  },
  {
    name: "versatile painting mediums",
    slug: "versatile-painting-mediums",
  },
  {
    name: "professional artist oil mediums",
    slug: "professional-artist-oil-mediums",
  },
  {
    name: "acrylic medium for layering",
    slug: "acrylic-medium-for-layering",
  },
  {
    name: "glazing medium for acrylics",
    slug: "glazing-medium-for-acrylics",
  },
  {
    name: "oil painting gloss mediums",
    slug: "oil-painting-gloss-mediums",
  },
  {
    name: "best medium for acrylics",
    slug: "best-medium-for-acrylics",
  },
  {
    name: "acrylic blending mediums",
    slug: "acrylic-blending-mediums",
  },
  {
    name: "durable oil painting mediums",
    slug: "durable-oil-painting-mediums",
  },
  {
    name: "watercolour lifting mediums",
    slug: "watercolour-lifting-mediums",
  },
  {
    name: "professional watercolour glazing medium",
    slug: "professional-watercolour-glazing-medium",
  },
  {
    name: "oil painting texture mediums",
    slug: "oil-painting-texture-mediums",
  },
  {
    name: "acrylic painting adhesive mediums",
    slug: "acrylic-painting-adhesive-mediums",
  },
  {
    name: "high-quality painting mediums",
    slug: "high-quality-painting-mediums",
  },
  {
    name: "water-mixable oil painting supplies",
    slug: "water-mixable-oil-painting-supplies",
  },
  {
    name: "top acrylic painting mediums",
    slug: "top-acrylic-painting-mediums",
  },
  {
    name: "acrylic painting extender mediums",
    slug: "acrylic-painting-extender-mediums",
  },
  {
    name: "oil-based painting additives",
    slug: "oil-based-painting-additives",
  },
  {
    name: "professional acrylic gel mediums",
    slug: "professional-acrylic-gel-mediums",
  },
  {
    name: "oil painting blending mediums",
    slug: "oil-painting-blending-mediums",
  },
  {
    name: "watercolour masking fluid mediums",
    slug: "watercolour-masking-fluid-mediums",
  },
  {
    name: "slow-drying acrylic mediums",
    slug: "slow-drying-acrylic-mediums",
  },
  {
    name: "artist-approved acrylic mediums",
    slug: "artist-approved-acrylic-mediums",
  },
  {
    name: "acrylic mediums for fine art",
    slug: "acrylic-mediums-for-fine-art",
  },
  {
    name: "professional-grade painting mediums",
    slug: "professional-grade-painting-mediums",
  },
  {
    name: "acrylic gloss gel mediums",
    slug: "acrylic-gloss-gel-mediums",
  },
  {
    name: "top-rated painting mediums",
    slug: "top-rated-painting-mediums",
  },
  {
    name: "watercolour painting extenders",
    slug: "watercolour-painting-extenders",
  },
  {
    name: "best oil painting additives",
    slug: "best-oil-painting-additives",
  },
  {
    name: "professional artist painting mediums",
    slug: "professional-artist-painting-mediums",
  },
  {
    name: "versatile oil painting mediums",
    slug: "versatile-oil-painting-mediums",
  },
  {
    name: "water-mixable oil gloss medium",
    slug: "water-mixable-oil-gloss-medium",
  },
  {
    name: "acrylic texture gel mediums",
    slug: "acrylic-texture-gel-mediums",
  },
  {
    name: "oil painting finishing mediums",
    slug: "oil-painting-finishing-mediums",
  },
  {
    name: "watercolour mediums for shading",
    slug: "watercolour-mediums-for-shading",
  },
  {
    name: "best acrylic matte medium",
    slug: "best-acrylic-matte-medium",
  },
  {
    name: "oil painting linseed mediums",
    slug: "oil-painting-linseed-mediums",
  },
  {
    name: "professional-quality acrylic mediums",
    slug: "professional-quality-acrylic-mediums",
  },
  {
    name: "high-pigment oil painting mediums",
    slug: "high-pigment-oil-painting-mediums",
  },
  {
    name: "acrylic mediums for acrylics",
    slug: "acrylic-mediums-for-acrylics",
  },
  {
    name: "oil painting layers medium",
    slug: "oil-painting-layers-medium",
  },
  {
    name: "best watercolour painting mediums",
    slug: "best-watercolour-painting-mediums",
  },
  {
    name: "professional-grade texture mediums",
    slug: "professional-grade-texture-mediums",
  },
  {
    name: "acrylic painting finishing mediums",
    slug: "acrylic-painting-finishing-mediums",
  },
  {
    name: "water-mixable oil glazing medium",
    slug: "water-mixable-oil-glazing-medium",
  },
  {
    name: "acrylic layering painting medium",
    slug: "acrylic-layering-painting-medium",
  },
  {
    name: "artist-preferred oil painting mediums",
    slug: "artist-preferred-oil-painting-mediums",
  },
  {
    name: "professional acrylic flow mediums",
    slug: "professional-acrylic-flow-mediums",
  },
  {
    name: "oil painting extender mediums",
    slug: "oil-painting-extender-mediums",
  },
  {
    name: "versatile acrylic painting mediums",
    slug: "versatile-acrylic-painting-mediums",
  },
  {
    name: "durable oil painting gloss medium",
    slug: "durable-oil-painting-gloss-medium",
  },
  {
    name: "best artist acrylic medium",
    slug: "best-artist-acrylic-medium",
  },
  {
    name: "smooth finish acrylic mediums",
    slug: "smooth-finish-acrylic-mediums",
  },
  {
    name: "oil medium for blending",
    slug: "oil-medium-for-blending",
  },
  {
    name: "watercolour painting texture mediums",
    slug: "watercolour-painting-texture-mediums",
  },
  {
    name: "acrylic painting tools medium",
    slug: "acrylic-painting-tools-medium",
  },
  {
    name: "top-quality oil painting medium",
    slug: "top-quality-oil-painting-medium",
  },
  {
    name: "artist-preferred acrylic painting mediums",
    slug: "artist-preferred-acrylic-painting-mediums",
  },
  {
    name: "water-mixable oil finishing medium",
    slug: "water-mixable-oil-finishing-medium",
  },
  {
    name: "oil painting slow-drying medium",
    slug: "oil-painting-slow-drying-medium",
  },
  {
    name: "acrylic adhesive layering medium",
    slug: "acrylic-adhesive-layering-medium",
  },
  {
    name: "best oil painting thinning medium",
    slug: "best-oil-painting-thinning-medium",
  },
  {
    name: "professional oil painting tools medium",
    slug: "professional-oil-painting-tools-medium",
  },
  {
    name: "acrylic medium for large paintings",
    slug: "acrylic-medium-for-large-paintings",
  },
  {
    name: "oil painting matte finishing medium",
    slug: "oil-painting-matte-finishing-medium",
  },
  {
    name: "versatile watercolour painting medium",
    slug: "versatile-watercolour-painting-medium",
  },
  {
    name: "professional-grade oil painting tools",
    slug: "professional-grade-oil-painting-tools",
  },
  {
    name: "artist-preferred painting medium",
    slug: "artist-preferred-painting-medium",
  },
  {
    name: "premium acrylic layering medium",
    slug: "premium-acrylic-layering-medium",
  },
  {
    name: "best water-mixable medium for oils",
    slug: "best-water-mixable-medium-for-oils",
  },
  {
    name: "durable oil texture medium",
    slug: "durable-oil-texture-medium",
  },
  {
    name: "oil painting advanced glazing medium",
    slug: "oil-painting-advanced-glazing-medium",
  },
  {
    name: "best oil-based painting medium",
    slug: "best-oil-based-painting-medium",
  },
  {
    name: "watercolour blending painting medium",
    slug: "watercolour-blending-painting-medium",
  },
  {
    name: "acrylic flow texture medium",
    slug: "acrylic-flow-texture-medium",
  },
  {
    name: "professional acrylic texture mediums",
    slug: "professional-acrylic-texture-mediums",
  },
  {
    name: "best art store",
    slug: "best-art-store",
  },
  {
    name: "professional art supplies",
    slug: "professional-art-supplies",
  },
  {
    name: "online art store",
    slug: "online-art-store",
  },
  {
    name: "art store near me",
    slug: "art-store-near-me",
  },
  {
    name: "affordable art store",
    slug: "affordable-art-store",
  },
  {
    name: "premium art supplies",
    slug: "premium-art-supplies",
  },
  {
    name: "local art store",
    slug: "local-art-store",
  },
  {
    name: "art supply shop",
    slug: "art-supply-shop",
  },
  {
    name: "artist supply store",
    slug: "artist-supply-store",
  },
  {
    name: "art materials online",
    slug: "art-materials-online",
  },
  {
    name: "top-rated art store",
    slug: "top-rated-art-store",
  },
  {
    name: "art shop sydney",
    slug: "art-shop-sydney",
  },
  {
    name: "art supply shop online",
    slug: "art-supply-shop-online",
  },
  {
    name: "artist materials store",
    slug: "artist-materials-store",
  },
  {
    name: "art supply online",
    slug: "art-supply-online",
  },
  {
    name: "fine art store",
    slug: "fine-art-store",
  },
  {
    name: "artist tools shop",
    slug: "artist-tools-shop",
  },
  {
    name: "affordable art supplies",
    slug: "affordable-art-supplies",
  },
  {
    name: "art equipment shop",
    slug: "art-equipment-shop",
  },
  {
    name: "best artist supplies",
    slug: "best-artist-supplies",
  },
  {
    name: "art products store",
    slug: "art-products-store",
  },
  {
    name: "art supply retailer",
    slug: "art-supply-retailer",
  },
  {
    name: "premium artist materials",
    slug: "premium-artist-materials",
  },
  {
    name: "sydney art supply store",
    slug: "sydney-art-supply-store",
  },
  {
    name: "professional artist tools",
    slug: "professional-artist-tools",
  },
  {
    name: "art materials near me",
    slug: "art-materials-near-me",
  },
  {
    name: "art equipment online",
    slug: "art-equipment-online",
  },
  {
    name: "quality art supplies",
    slug: "quality-art-supplies",
  },
  {
    name: "artist tools store",
    slug: "artist-tools-store",
  },
  {
    name: "art supply shop sydney",
    slug: "art-supply-shop-sydney",
  },
  {
    name: "artist materials shop",
    slug: "artist-materials-shop",
  },
  {
    name: "best art equipment",
    slug: "best-art-equipment",
  },
  {
    name: "art materials australia",
    slug: "art-materials-australia",
  },
  {
    name: "discount art supplies",
    slug: "discount-art-supplies",
  },
  {
    name: "affordable artist supplies",
    slug: "affordable-artist-supplies",
  },
  {
    name: "professional-grade art materials",
    slug: "professional-grade-art-materials",
  },
  {
    name: "art supply shop near me",
    slug: "art-supply-shop-near-me",
  },
  {
    name: "artist tool shop",
    slug: "artist-tool-shop",
  },
  {
    name: "best art supply store",
    slug: "best-art-supply-store",
  },
  {
    name: "sydney art materials shop",
    slug: "sydney-art-materials-shop",
  },
  {
    name: "fine artist supplies",
    slug: "fine-artist-supplies",
  },
  {
    name: "high-end art supplies",
    slug: "high-end-art-supplies",
  },
  {
    name: "artist essentials shop",
    slug: "artist-essentials-shop",
  },
  {
    name: "professional art supply shop",
    slug: "professional-art-supply-shop",
  },
  {
    name: "artist materials retailer",
    slug: "artist-materials-retailer",
  },
  {
    name: "sydney online art store",
    slug: "sydney-online-art-store",
  },
  {
    name: "art tools for professionals",
    slug: "art-tools-for-professionals",
  },
  {
    name: "creative art supplies",
    slug: "creative-art-supplies",
  },
  {
    name: "best online art supplies",
    slug: "best-online-art-supplies",
  },
  {
    name: "top-rated art supply shop",
    slug: "top-rated-art-supply-shop",
  },
  {
    name: "professional-grade art materials",
    slug: "professional-grade-art-materials",
  },
  {
    name: "art equipment outlet",
    slug: "art-equipment-outlet",
  },
  {
    name: "best art tools",
    slug: "best-art-tools",
  },
  {
    name: "artist supply shop sydney",
    slug: "artist-supply-shop-sydney",
  },
  {
    name: "artist materials outlet",
    slug: "artist-materials-outlet",
  },
  {
    name: "sydney creative art supplies",
    slug: "sydney-creative-art-supplies",
  },
  {
    name: "fine art tools",
    slug: "fine-art-tools",
  },
  {
    name: "art materials shop sydney",
    slug: "art-materials-shop-sydney",
  },
  {
    name: "quality art materials store",
    slug: "quality-art-materials-store",
  },
  {
    name: "artist equipment retailer",
    slug: "artist-equipment-retailer",
  },
  {
    name: "online artist supply store",
    slug: "online-artist-supply-store",
  },
  {
    name: "art materials distributor",
    slug: "art-materials-distributor",
  },
  {
    name: "art supply outlet sydney",
    slug: "art-supply-outlet-sydney",
  },
  {
    name: "affordable art products",
    slug: "affordable-art-products",
  },
  {
    name: "premium quality art supplies",
    slug: "premium-quality-art-supplies",
  },
  {
    name: "sydney artist tools shop",
    slug: "sydney-artist-tools-shop",
  },
  {
    name: "best professional art supplies",
    slug: "best-professional-art-supplies",
  },
  {
    name: "artist tools for sale",
    slug: "artist-tools-for-sale",
  },
  {
    name: "best creative art supplies",
    slug: "best-creative-art-supplies",
  },
  {
    name: "professional-grade art supply store",
    slug: "professional-grade-art-supply-store",
  },
  {
    name: "artist supply store online",
    slug: "artist-supply-store-online",
  },
  {
    name: "affordable professional art supplies",
    slug: "affordable-professional-art-supplies",
  },
  {
    name: "quality art products sydney",
    slug: "quality-art-products-sydney",
  },
  {
    name: "artist materials shop near me",
    slug: "artist-materials-shop-near-me",
  },
  {
    name: "fine art supply shop",
    slug: "fine-art-supply-shop",
  },
  {
    name: "best art supply retailer",
    slug: "best-art-supply-retailer",
  },
  {
    name: "affordable artist materials sydney",
    slug: "affordable-artist-materials-sydney",
  },
  {
    name: "high-quality artist tools",
    slug: "high-quality-artist-tools",
  },
  {
    name: "premium art materials shop",
    slug: "premium-art-materials-shop",
  },
  {
    name: "sydney art materials store",
    slug: "sydney-art-materials-store",
  },
  {
    name: "online art materials store",
    slug: "online-art-materials-store",
  },
  {
    name: "artist-grade art supply shop",
    slug: "artist-grade-art-supply-shop",
  },
  {
    name: "art tools and supplies",
    slug: "art-tools-and-supplies",
  },
  {
    name: "local art supply shop",
    slug: "local-art-supply-shop",
  },
  {
    name: "reliable art materials shop",
    slug: "reliable-art-materials-shop",
  },
  {
    name: "top art supply store",
    slug: "top-art-supply-store",
  },
  {
    name: "artist tools shop sydney",
    slug: "artist-tools-shop-sydney",
  },
  {
    name: "art store for artists",
    slug: "art-store-for-artists",
  },
  {
    name: "affordable art tools shop",
    slug: "affordable-art-tools-shop",
  },
  {
    name: "art supply store near me",
    slug: "art-supply-store-near-me",
  },
  {
    name: "quality artist tools store",
    slug: "quality-artist-tools-store",
  },
  {
    name: "best art materials store",
    slug: "best-art-materials-store",
  },
  {
    name: "local artist materials shop",
    slug: "local-artist-materials-shop",
  },
  {
    name: "artist-grade art supplies",
    slug: "artist-grade-art-supplies",
  },
  {
    name: "sydney artist supplies store",
    slug: "sydney-artist-supplies-store",
  },
  {
    name: "premium art tools shop",
    slug: "premium-art-tools-shop",
  },
  {
    name: "professional art materials shop",
    slug: "professional-art-materials-shop",
  },
  {
    name: "online art tools store",
    slug: "online-art-tools-store",
  },
  {
    name: "artist tools for beginners",
    slug: "artist-tools-for-beginners",
  },
  {
    name: "best art supply shop",
    slug: "best-art-supply-shop",
  },
  {
    name: "best art resin",
    slug: "best-art-resin",
  },
  {
    name: "epoxy resin for art",
    slug: "epoxy-resin-for-art",
  },
  {
    name: "professional art resin",
    slug: "professional-art-resin",
  },
  {
    name: "resin for art projects",
    slug: "resin-for-art-projects",
  },
  {
    name: "art resin near me",
    slug: "art-resin-near-me",
  },
  {
    name: "high-quality art resin",
    slug: "high-quality-art-resin",
  },
  {
    name: "clear resin for art",
    slug: "clear-resin-for-art",
  },
  {
    name: "affordable art resin",
    slug: "affordable-art-resin",
  },
  {
    name: "resin for acrylic pouring",
    slug: "resin-for-acrylic-pouring",
  },
  {
    name: "art resin supplies online",
    slug: "art-resin-supplies-online",
  },
  {
    name: "resin for canvas art",
    slug: "resin-for-canvas-art",
  },
  {
    name: "top-rated art resin",
    slug: "top-rated-art-resin",
  },
  {
    name: "art resin for beginners",
    slug: "art-resin-for-beginners",
  },
  {
    name: "professional-grade art resin",
    slug: "professional-grade-art-resin",
  },
  {
    name: "best resin for art",
    slug: "best-resin-for-art",
  },
  {
    name: "resin for fine art",
    slug: "resin-for-fine-art",
  },
  {
    name: "art resin for painting",
    slug: "art-resin-for-painting",
  },
  {
    name: "artist resin supplies",
    slug: "artist-resin-supplies",
  },
  {
    name: "non-toxic art resin",
    slug: "non-toxic-art-resin",
  },
  {
    name: "resin for mixed media",
    slug: "resin-for-mixed-media",
  },
  {
    name: "art resin for crafts",
    slug: "art-resin-for-crafts",
  },
  {
    name: "premium resin for art",
    slug: "premium-resin-for-art",
  },
  {
    name: "high-gloss art resin",
    slug: "high-gloss-art-resin",
  },
  {
    name: "art resin for professionals",
    slug: "art-resin-for-professionals",
  },
  {
    name: "epoxy resin wall art?",
    slug: "epoxy-resin-wall-art?",
  },
  {
    name: "resin for abstract art",
    slug: "resin-for-abstract-art",
  },
  {
    name: "resin art calculator?",
    slug: "resin-art-calculator?",
  },
  {
    name: "best resin for acrylics",
    slug: "best-resin-for-acrylics",
  },
  {
    name: "clear epoxy resin for art",
    slug: "clear-epoxy-resin-for-art",
  },
  {
    name: "epoxy resin art",
    slug: "epoxy-resin-art",
  },
  {
    name: "resin for art coating",
    slug: "resin-for-art-coating",
  },
  {
    name: "resin art ideas",
    slug: "resin-art-ideas",
  },
  {
    name: "resin for professional artists",
    slug: "resin-for-professional-artists",
  },
  {
    name: "best epoxy resin for art",
    slug: "best-epoxy-resin-for-art",
  },
  {
    name: "versatile resin for art",
    slug: "versatile-resin-for-art",
  },
  {
    name: "resin for diy art",
    slug: "resin-for-diy-art",
  },
  {
    name: "top-quality resin for art",
    slug: "top-quality-resin-for-art",
  },
  {
    name: "resin art kit?",
    slug: "resin-art-kit?",
  },
  {
    name: "premium art resin supplies",
    slug: "premium-art-resin-supplies",
  },
  {
    name: "best clear resin for art",
    slug: "best-clear-resin-for-art",
  },
  {
    name: "resin for large-scale art",
    slug: "resin-for-large-scale-art",
  },
  {
    name: "glossy finish art resin",
    slug: "glossy-finish-art-resin",
  },
  {
    name: "artist resin for crafts",
    slug: "artist-resin-for-crafts",
  },
  {
    name: "resin for intricate art",
    slug: "resin-for-intricate-art",
  },
  {
    name: "resin wall art?",
    slug: "resin-wall-art?",
  },
  {
    name: "art resin calculator",
    slug: "art-resin-calculator",
  },
  {
    name: "high-gloss resin for art",
    slug: "high-gloss-resin-for-art",
  },
  {
    name: "art resin epoxy?",
    slug: "art-resin-epoxy?",
  },
  {
    name: "best resin for fine art",
    slug: "best-resin-for-fine-art",
  },
  {
    name: "resin art epoxy?",
    slug: "resin-art-epoxy?",
  },
  {
    name: "high-gloss epoxy resin",
    slug: "high-gloss-epoxy-resin",
  },
  {
    name: "resin for tabletop art",
    slug: "resin-for-tabletop-art",
  },
  {
    name: "clear coat art resin",
    slug: "clear-coat-art-resin",
  },
  {
    name: "resin art supplies?",
    slug: "resin-art-supplies?",
  },
  {
    name: "resin for sculptural art",
    slug: "resin-for-sculptural-art",
  },
  {
    name: "resin for 3d art",
    slug: "resin-for-3d-art",
  },
  {
    name: "art resin for deep pours",
    slug: "art-resin-for-deep-pours",
  },
  {
    name: "artist epoxy resin supplies",
    slug: "artist-epoxy-resin-supplies",
  },
  {
    name: "resin art products?",
    slug: "resin-art-products?",
  },
  {
    name: "premium epoxy resin for art",
    slug: "premium-epoxy-resin-for-art",
  },
  {
    name: "resin for casting art",
    slug: "resin-for-casting-art",
  },
  {
    name: "beginner-friendly art resin",
    slug: "beginner-friendly-art-resin",
  },
  {
    name: "art resin for experienced artists",
    slug: "art-resin-for-experienced-artists",
  },
  {
    name: "affordable epoxy resin for art",
    slug: "affordable-epoxy-resin-for-art",
  },
  {
    name: "resin for decorative art",
    slug: "resin-for-decorative-art",
  },
  {
    name: "crystal-clear resin for art",
    slug: "crystal-clear-resin-for-art",
  },
  {
    name: "top resin for painting",
    slug: "top-resin-for-painting",
  },
  {
    name: "professional resin for acrylics",
    slug: "professional-resin-for-acrylics",
  },
  {
    name: "resin for vibrant art",
    slug: "resin-for-vibrant-art",
  },
  {
    name: "high-quality epoxy resin",
    slug: "high-quality-epoxy-resin",
  },
  {
    name: "best resin for coatings",
    slug: "best-resin-for-coatings",
  },
  {
    name: "durable epoxy resin for art",
    slug: "durable-epoxy-resin-for-art",
  },
  {
    name: "art resin for environmental sealing",
    slug: "art-resin-for-environmental-sealing",
  },
  {
    name: "resin for layered art",
    slug: "resin-for-layered-art",
  },
  {
    name: "resin for textured art",
    slug: "resin-for-textured-art",
  },
  {
    name: "clear resin for pouring",
    slug: "clear-resin-for-pouring",
  },
  {
    name: "artist resin for advanced techniques",
    slug: "artist-resin-for-advanced-techniques",
  },
  {
    name: "art resin for jewelry",
    slug: "art-resin-for-jewelry",
  },
  {
    name: "resin for resin molds",
    slug: "resin-for-resin-molds",
  },
  {
    name: "best resin for art projects",
    slug: "best-resin-for-art-projects",
  },
  {
    name: "art resin for waterproof coatings",
    slug: "art-resin-for-waterproof-coatings",
  },
  {
    name: "professional resin for fine art",
    slug: "professional-resin-for-fine-art",
  },
  {
    name: "high-clarity resin for art",
    slug: "high-clarity-resin-for-art",
  },
  {
    name: "non-toxic resin for art",
    slug: "non-toxic-resin-for-art",
  },
  {
    name: "resin for high-detail art",
    slug: "resin-for-high-detail-art",
  },
  {
    name: "resin for surface coatings",
    slug: "resin-for-surface-coatings",
  },
  {
    name: "best resin for decorative art",
    slug: "best-resin-for-decorative-art",
  },
  {
    name: "art resin for classroom use",
    slug: "art-resin-for-classroom-use",
  },
  {
    name: "resin for vibrant finishes",
    slug: "resin-for-vibrant-finishes",
  },
  {
    name: "professional resin for artists",
    slug: "professional-resin-for-artists",
  },
  {
    name: "best art resin supplies",
    slug: "best-art-resin-supplies",
  },
  {
    name: "art resin for exhibitions",
    slug: "art-resin-for-exhibitions",
  },
  {
    name: "art resin for glass-like finishes",
    slug: "art-resin-for-glass-like-finishes",
  },
  {
    name: "resin for contemporary art",
    slug: "resin-for-contemporary-art",
  },
  {
    name: "clear resin for deep pours",
    slug: "clear-resin-for-deep-pours",
  },
  {
    name: "best art resin for durability",
    slug: "best-art-resin-for-durability",
  },
  {
    name: "resin for color layering",
    slug: "resin-for-color-layering",
  },
  {
    name: "artist resin for unique effects",
    slug: "artist-resin-for-unique-effects",
  },
  {
    name: "top-rated resin for painting",
    slug: "top-rated-resin-for-painting",
  },
  {
    name: "resin for artistic applications",
    slug: "resin-for-artistic-applications",
  },
  {
    name: "best art varnish",
    slug: "best-art-varnish",
  },
  {
    name: "professional art varnish",
    slug: "professional-art-varnish",
  },
  {
    name: "varnish for acrylic painting",
    slug: "varnish-for-acrylic-painting",
  },
  {
    name: "clear varnish for art",
    slug: "clear-varnish-for-art",
  },
  {
    name: "varnish for oil painting",
    slug: "varnish-for-oil-painting",
  },
  {
    name: "art varnish supplies online",
    slug: "art-varnish-supplies-online",
  },
  {
    name: "high-quality art varnish",
    slug: "high-quality-art-varnish",
  },
  {
    name: "durable varnish for art",
    slug: "durable-varnish-for-art",
  },
  {
    name: "best varnish for paintings",
    slug: "best-varnish-for-paintings",
  },
  {
    name: "matte varnish for acrylics",
    slug: "matte-varnish-for-acrylics",
  },
  {
    name: "gloss varnish for paintings",
    slug: "gloss-varnish-for-paintings",
  },
  {
    name: "artist-grade painting varnish",
    slug: "artist-grade-painting-varnish",
  },
  {
    name: "top-rated art varnish",
    slug: "top-rated-art-varnish",
  },
  {
    name: "satin varnish for art",
    slug: "satin-varnish-for-art",
  },
  {
    name: "non-yellowing art varnish",
    slug: "non-yellowing-art-varnish",
  },
  {
    name: "uv-resistant varnish for art",
    slug: "uv-resistant-varnish-for-art",
  },
  {
    name: "acrylic gloss varnish supplies",
    slug: "acrylic-gloss-varnish-supplies",
  },
  {
    name: "oil painting gloss varnish",
    slug: "oil-painting-gloss-varnish",
  },
  {
    name: "varnish for mixed media",
    slug: "varnish-for-mixed-media",
  },
  {
    name: "acrylic painting varnish?",
    slug: "acrylic-painting-varnish?",
  },
  {
    name: "water-based varnish for art",
    slug: "water-based-varnish-for-art",
  },
  {
    name: "solvent-based art varnish",
    slug: "solvent-based-art-varnish",
  },
  {
    name: "varnish for protecting paintings",
    slug: "varnish-for-protecting-paintings",
  },
  {
    name: "varnishing acrylic paintings?",
    slug: "varnishing-acrylic-paintings?",
  },
  {
    name: "clear protective varnish for art",
    slug: "clear-protective-varnish-for-art",
  },
  {
    name: "high-performance art varnish",
    slug: "high-performance-art-varnish",
  },
  {
    name: "gloss finish varnish for acrylics",
    slug: "gloss-finish-varnish-for-acrylics",
  },
  {
    name: "durable varnish for oil paintings",
    slug: "durable-varnish-for-oil-paintings",
  },
  {
    name: "acrylic painting matte varnish",
    slug: "acrylic-painting-matte-varnish",
  },
  {
    name: "varnish on acrylic paint?",
    slug: "varnish-on-acrylic-paint?",
  },
  {
    name: "varnishing acrylic",
    slug: "varnishing-acrylic",
  },
  {
    name: "art varnish for exhibitions",
    slug: "art-varnish-for-exhibitions",
  },
  {
    name: "best acrylic varnish?",
    slug: "best-acrylic-varnish?",
  },
  {
    name: "protective varnish for artwork",
    slug: "protective-varnish-for-artwork",
  },
  {
    name: "best varnish for fine art",
    slug: "best-varnish-for-fine-art",
  },
  {
    name: "varnish for acrylic?",
    slug: "varnish-for-acrylic?",
  },
  {
    name: "satin finish varnish for art",
    slug: "satin-finish-varnish-for-art",
  },
  {
    name: "varnish for vibrant paintings",
    slug: "varnish-for-vibrant-paintings",
  },
  {
    name: "archival varnish for artwork",
    slug: "archival-varnish-for-artwork",
  },
  {
    name: "best varnish for canvas",
    slug: "best-varnish-for-canvas",
  },
  {
    name: "varnish for oil  ",
    slug: "varnish-for-oil--",
  },
  {
    name: "varnish for detailed artwork",
    slug: "varnish-for-detailed-artwork",
  },
  {
    name: "artist-approved varnish for paintings",
    slug: "artist-approved-varnish-for-paintings",
  },
  {
    name: "quick-drying art varnish",
    slug: "quick-drying-art-varnish",
  },
  {
    name: "premium-quality painting varnish",
    slug: "premium-quality-painting-varnish",
  },
  {
    name: "varnish for long-lasting finishes",
    slug: "varnish-for-long-lasting-finishes",
  },
  {
    name: "acrylic painting satin varnish",
    slug: "acrylic-painting-satin-varnish",
  },
  {
    name: "affordable varnish for artwork",
    slug: "affordable-varnish-for-artwork",
  },
  {
    name: "clear art varnish supplies",
    slug: "clear-art-varnish-supplies",
  },
  {
    name: "top varnish for acrylics",
    slug: "top-varnish-for-acrylics",
  },
  {
    name: "best varnish for oil paintings",
    slug: "best-varnish-for-oil-paintings",
  },
  {
    name: "artist varnish for exhibitions",
    slug: "artist-varnish-for-exhibitions",
  },
  {
    name: "professional matte art varnish",
    slug: "professional-matte-art-varnish",
  },
  {
    name: "uv-protective varnish for paintings",
    slug: "uv-protective-varnish-for-paintings",
  },
  {
    name: "durable gloss varnish for art",
    slug: "durable-gloss-varnish-for-art",
  },
  {
    name: "satin varnish for acrylic paintings",
    slug: "satin-varnish-for-acrylic-paintings",
  },
  {
    name: "high-gloss varnish for artwork",
    slug: "high-gloss-varnish-for-artwork",
  },
  {
    name: "varnish for large-scale paintings",
    slug: "varnish-for-large-scale-paintings",
  },
  {
    name: "versatile art varnish supplies",
    slug: "versatile-art-varnish-supplies",
  },
  {
    name: "best art varnish for professionals",
    slug: "best-art-varnish-for-professionals",
  },
  {
    name: "professional painting gloss varnish",
    slug: "professional-painting-gloss-varnish",
  },
  {
    name: "varnish for textured artwork",
    slug: "varnish-for-textured-artwork",
  },
  {
    name: "best art varnish for beginners",
    slug: "best-art-varnish-for-beginners",
  },
  {
    name: "varnish for intricate details",
    slug: "varnish-for-intricate-details",
  },
  {
    name: "artist-grade satin varnish",
    slug: "artist-grade-satin-varnish",
  },
  {
    name: "top-rated gloss varnish",
    slug: "top-rated-gloss-varnish",
  },
  {
    name: "professional-grade matte varnish",
    slug: "professional-grade-matte-varnish",
  },
  {
    name: "uv-stable varnish for artwork",
    slug: "uv-stable-varnish-for-artwork",
  },
  {
    name: "varnish for acrylic pour paintings",
    slug: "varnish-for-acrylic-pour-paintings",
  },
  {
    name: "quick-dry varnish for art",
    slug: "quick-dry-varnish-for-art",
  },
  {
    name: "clear gloss varnish for canvas",
    slug: "clear-gloss-varnish-for-canvas",
  },
  {
    name: "affordable matte varnish for art",
    slug: "affordable-matte-varnish-for-art",
  },
  {
    name: "artist-preferred satin varnish",
    slug: "artist-preferred-satin-varnish",
  },
  {
    name: "solvent-free varnish for artwork",
    slug: "solvent-free-varnish-for-artwork",
  },
  {
    name: "high-quality varnish for paintings",
    slug: "high-quality-varnish-for-paintings",
  },
  {
    name: "durable matte varnish for acrylics",
    slug: "durable-matte-varnish-for-acrylics",
  },
  {
    name: "varnish for professional artwork",
    slug: "varnish-for-professional-artwork",
  },
  {
    name: "canvas varnish acrylic?",
    slug: "canvas-varnish-acrylic?",
  },
  {
    name: "varnish for acrylic painting?",
    slug: "varnish-for-acrylic-painting?",
  },
  {
    name: "varnish for modern art projects",
    slug: "varnish-for-modern-art-projects",
  },
  {
    name: "varnish on acrylic?",
    slug: "varnish-on-acrylic?",
  },
  {
    name: "oil varnish?",
    slug: "oil-varnish?",
  },
  {
    name: "acrylic varnish?",
    slug: "acrylic-varnish?",
  },
  {
    name: "acrylic color varnish?",
    slug: "acrylic-color-varnish?",
  },
  {
    name: "varnishing an oil painting?",
    slug: "varnishing-an-oil-painting?",
  },
  {
    name: "varnish for vibrant art pieces",
    slug: "varnish-for-vibrant-art-pieces",
  },
  {
    name: "oil based wood varnish?",
    slug: "oil-based-wood-varnish?",
  },
  {
    name: "oil based varnish for wood?",
    slug: "oil-based-varnish-for-wood?",
  },
  {
    name: "clear acrylic varnish for art",
    slug: "clear-acrylic-varnish-for-art",
  },
  {
    name: "varnish for preserving fine art",
    slug: "varnish-for-preserving-fine-art",
  },
  {
    name: "varnish on oil painting?",
    slug: "varnish-on-oil-painting?",
  },
  {
    name: "varnish on acrylic painting?",
    slug: "varnish-on-acrylic-painting?",
  },
  {
    name: "best acrylic varnish",
    slug: "best-acrylic-varnish",
  },
  {
    name: "best oil varnish",
    slug: "best-oil-varnish",
  },
  {
    name: "oil and varnish?",
    slug: "oil-and-varnish?",
  },
  {
    name: "oil based varnish?",
    slug: "oil-based-varnish?",
  },
  {
    name: "acrylic based varnish?",
    slug: "acrylic-based-varnish?",
  },
  {
    name: "varnish for wood?",
    slug: "varnish-for-wood?",
  },
  {
    name: "oil varnish painting?",
    slug: "oil-varnish-painting?",
  },
  {
    name: "oil painting? varnish",
    slug: "oil-painting?-varnish",
  },
  {
    name: "best art storage",
    slug: "best-art-storage",
  },
  {
    name: "professional art storage",
    slug: "professional-art-storage",
  },
  {
    name: "art storage box",
    slug: "art-storage-box",
  },
  {
    name: "artist storage solutions",
    slug: "artist-storage-solutions",
  },
  {
    name: "storage box for art",
    slug: "storage-box-for-art",
  },
  {
    name: "affordable art storage",
    slug: "affordable-art-storage",
  },
  {
    name: "artist supply storage",
    slug: "artist-supply-storage",
  },
  {
    name: "best art supply box",
    slug: "best-art-supply-box",
  },
  {
    name: "art storage containers",
    slug: "art-storage-containers",
  },
  {
    name: "art supply storage solutions",
    slug: "art-supply-storage-solutions",
  },
  {
    name: "artist tool storage",
    slug: "artist-tool-storage",
  },
  {
    name: "portable art storage box",
    slug: "portable-art-storage-box",
  },
  {
    name: "art storage for canvas",
    slug: "art-storage-for-canvas",
  },
  {
    name: "top-rated art storage",
    slug: "top-rated-art-storage",
  },
  {
    name: "artist-grade storage boxes",
    slug: "artist-grade-storage-boxes",
  },
  {
    name: "art storage for supplies",
    slug: "art-storage-for-supplies",
  },
  {
    name: "art storage for brushes",
    slug: "art-storage-for-brushes",
  },
  {
    name: "storage solutions for artists",
    slug: "storage-solutions-for-artists",
  },
  {
    name: "art storage drawer systems",
    slug: "art-storage-drawer-systems",
  },
  {
    name: "compact art storage box",
    slug: "compact-art-storage-box",
  },
  {
    name: "durable art storage solutions",
    slug: "durable-art-storage-solutions",
  },
  {
    name: "art supply organizer box",
    slug: "art-supply-organizer-box",
  },
  {
    name: "storage case for art supplies",
    slug: "storage-case-for-art-supplies",
  },
  {
    name: "art storage for studios",
    slug: "art-storage-for-studios",
  },
  {
    name: "best artist storage solutions",
    slug: "best-artist-storage-solutions",
  },
  {
    name: "art storage for small spaces",
    slug: "art-storage-for-small-spaces",
  },
  {
    name: "storage box for painting tools",
    slug: "storage-box-for-painting-tools",
  },
  {
    name: "high-quality art storage",
    slug: "high-quality-art-storage",
  },
  {
    name: "artist portfolio storage case",
    slug: "artist-portfolio-storage-case",
  },
  {
    name: "stackable art storage containers",
    slug: "stackable-art-storage-containers",
  },
  {
    name: "professional-grade art storage",
    slug: "professional-grade-art-storage",
  },
  {
    name: "art storage with compartments",
    slug: "art-storage-with-compartments",
  },
  {
    name: "art supply storage organizer",
    slug: "art-supply-storage-organizer",
  },
  {
    name: "best portable art storage",
    slug: "best-portable-art-storage",
  },
  {
    name: "artist toolbox for supplies",
    slug: "artist-toolbox-for-supplies",
  },
  {
    name: "art storage for transport",
    slug: "art-storage-for-transport",
  },
  {
    name: "lightweight art storage solutions",
    slug: "lightweight-art-storage-solutions",
  },
  {
    name: "top-rated artist storage box",
    slug: "top-rated-artist-storage-box",
  },
  {
    name: "best art supply organizer",
    slug: "best-art-supply-organizer",
  },
  {
    name: "art storage for classrooms",
    slug: "art-storage-for-classrooms",
  },
  {
    name: "artist supplies storage solutions",
    slug: "artist-supplies-storage-solutions",
  },
  {
    name: "art storage for large tools",
    slug: "art-storage-for-large-tools",
  },
  {
    name: "art supply storage cabinets",
    slug: "art-supply-storage-cabinets",
  },
  {
    name: "compact artist storage solutions",
    slug: "compact-artist-storage-solutions",
  },
  {
    name: "art tool organizer box",
    slug: "art-tool-organizer-box",
  },
  {
    name: "portable artist storage case",
    slug: "portable-artist-storage-case",
  },
  {
    name: "best art storage for studios",
    slug: "best-art-storage-for-studios",
  },
  {
    name: "stackable artist storage bins",
    slug: "stackable-artist-storage-bins",
  },
  {
    name: "artist tool storage container",
    slug: "artist-tool-storage-container",
  },
  {
    name: "affordable storage for artists",
    slug: "affordable-storage-for-artists",
  },
  {
    name: "art supply storage for travel",
    slug: "art-supply-storage-for-travel",
  },
  {
    name: "art storage with dividers",
    slug: "art-storage-with-dividers",
  },
  {
    name: "artist-grade storage for supplies",
    slug: "artist-grade-storage-for-supplies",
  },
  {
    name: "best compact art storage box",
    slug: "best-compact-art-storage-box",
  },
  {
    name: "professional art organizer box",
    slug: "professional-art-organizer-box",
  },
  {
    name: "art storage solutions for studios",
    slug: "art-storage-solutions-for-studios",
  },
  {
    name: "portable art supply storage",
    slug: "portable-art-supply-storage",
  },
  {
    name: "durable artist toolbox organizer",
    slug: "durable-artist-toolbox-organizer",
  },
  {
    name: "top-rated art supply storage",
    slug: "top-rated-art-supply-storage",
  },
  {
    name: "art storage for delicate supplies",
    slug: "art-storage-for-delicate-supplies",
  },
  {
    name: "artist-grade storage solutions",
    slug: "artist-grade-storage-solutions",
  },
  {
    name: "art supply storage for professionals",
    slug: "art-supply-storage-for-professionals",
  },
  {
    name: "best storage for painting supplies",
    slug: "best-storage-for-painting-supplies",
  },
  {
    name: "art storage with secure locking",
    slug: "art-storage-with-secure-locking",
  },
  {
    name: "art tools storage?",
    slug: "art-tools-storage?",
  },
  {
    name: "art tool storage?",
    slug: "art-tool-storage?",
  },
  {
    name: "affordable artist tool storage",
    slug: "affordable-artist-tool-storage",
  },
  {
    name: "art storage for portfolios",
    slug: "art-storage-for-portfolios",
  },
  {
    name: "art supply box with compartments",
    slug: "art-supply-box-with-compartments",
  },
  {
    name: "fine art storage?",
    slug: "fine-art-storage?",
  },
  {
    name: "artist storage case for tools",
    slug: "artist-storage-case-for-tools",
  },
  {
    name: "high-quality art supply organizer",
    slug: "high-quality-art-supply-organizer",
  },
  {
    name: "storage solutions for art studios",
    slug: "storage-solutions-for-art-studios",
  },
  {
    name: "best art supply storage systems",
    slug: "best-art-supply-storage-systems",
  },
  {
    name: "art material storage?",
    slug: "art-material-storage?",
  },
  {
    name: "art organizer box for travel",
    slug: "art-organizer-box-for-travel",
  },
  {
    name: "best storage for brushes",
    slug: "best-storage-for-brushes",
  },
  {
    name: "artist storage for large tools",
    slug: "artist-storage-for-large-tools",
  },
  {
    name: "art canvas storage?",
    slug: "art-canvas-storage?",
  },
  {
    name: "compact art supply storage box",
    slug: "compact-art-supply-storage-box",
  },
  {
    name: "art box storage?",
    slug: "art-box-storage?",
  },
  {
    name: "art storage containers?",
    slug: "art-storage-containers?",
  },
  {
    name: "best art supply box for beginners",
    slug: "best-art-supply-box-for-beginners",
  },
  {
    name: "lightweight art supply organizer",
    slug: "lightweight-art-supply-organizer",
  },
  {
    name: "artist supply case for tools",
    slug: "artist-supply-case-for-tools",
  },
  {
    name: "portable art storage for professionals",
    slug: "portable-art-storage-for-professionals",
  },
  {
    name: "art storage box?",
    slug: "art-storage-box?",
  },
  {
    name: "kids art storage?",
    slug: "kids-art-storage?",
  },
  {
    name: "professional art supply organizer case",
    slug: "professional-art-supply-organizer-case",
  },
  {
    name: "art supply organizer for studios",
    slug: "art-supply-organizer-for-studios",
  },
  {
    name: "best art storage containers for supplies",
    slug: "best-art-storage-containers-for-supplies",
  },
  {
    name: "artist supply storage for travel",
    slug: "artist-supply-storage-for-travel",
  },
  {
    name: "storage for art?",
    slug: "storage-for-art?",
  },
  {
    name: "paper art storage?",
    slug: "paper-art-storage?",
  },
  {
    name: "art storage boxes?",
    slug: "art-storage-boxes?",
  },
  {
    name: "best art container",
    slug: "best-art-container",
  },
  {
    name: "best art box",
    slug: "best-art-box",
  },
  {
    name: "art table and storage?",
    slug: "art-table-and-storage?",
  },
  {
    name: "art portfolio storage?",
    slug: "art-portfolio-storage?",
  },
  {
    name: "art storage organizer?",
    slug: "art-storage-organizer?",
  },
  {
    name: "best oil paints",
    slug: "best-oil-paints",
  },
  {
    name: "professional acrylic paints",
    slug: "professional-acrylic-paints",
  },
  {
    name: "watercolour paints near me",
    slug: "watercolour-paints-near-me",
  },
  {
    name: "high-quality gouache paints",
    slug: "high-quality-gouache-paints",
  },
  {
    name: "aerosol paints for artists",
    slug: "aerosol-paints-for-artists",
  },
  {
    name: "acrylic paints for beginners",
    slug: "acrylic-paints-for-beginners",
  },
  {
    name: "best watercolour paints",
    slug: "best-watercolour-paints",
  },
  {
    name: "professional oil paints",
    slug: "professional-oil-paints",
  },
  {
    name: "gouache paints for illustrations",
    slug: "gouache-paints-for-illustrations",
  },
  {
    name: "aerosol paints for murals",
    slug: "aerosol-paints-for-murals",
  },
  {
    name: "acrylic paints for canvas",
    slug: "acrylic-paints-for-canvas",
  },
  {
    name: "best acrylic painting supplies",
    slug: "best-acrylic-painting-supplies",
  },
  {
    name: "watercolour painting sets online",
    slug: "watercolour-painting-sets-online",
  },
  {
    name: "oil paints for professionals",
    slug: "oil-paints-for-professionals",
  },
  {
    name: "gouache paints for students",
    slug: "gouache-paints-for-students",
  },
  {
    name: "premium quality oil paints",
    slug: "premium-quality-oil-paints",
  },
  {
    name: "best gouache paints",
    slug: "best-gouache-paints",
  },
  {
    name: "top-rated acrylic paints",
    slug: "top-rated-acrylic-paints",
  },
  {
    name: "aerosol paints for graffiti",
    slug: "aerosol-paints-for-graffiti",
  },
  {
    name: "watercolour painting supplies",
    slug: "watercolour-painting-supplies",
  },
  {
    name: "artist-grade oil paints",
    slug: "artist-grade-oil-paints",
  },
  {
    name: "watercolour paints for artists",
    slug: "watercolour-paints-for-artists",
  },
  {
    name: "acrylic painting supplies online",
    slug: "acrylic-painting-supplies-online",
  },
  {
    name: "oil painting starter sets",
    slug: "oil-painting-starter-sets",
  },
  {
    name: "professional watercolour paints",
    slug: "professional-watercolour-paints",
  },
  {
    name: "best paints for canvas",
    slug: "best-paints-for-canvas",
  },
  {
    name: "gouache painting kits online",
    slug: "gouache-painting-kits-online",
  },
  {
    name: "artist-quality acrylic paints",
    slug: "artist-quality-acrylic-paints",
  },
  {
    name: "best aerosol paints for walls",
    slug: "best-aerosol-paints-for-walls",
  },
  {
    name: "watercolour paints for professionals",
    slug: "watercolour-paints-for-professionals",
  },
  {
    name: "oil paints for fine art",
    slug: "oil-paints-for-fine-art",
  },
  {
    name: "gouache paints for mixed media",
    slug: "gouache-paints-for-mixed-media",
  },
  {
    name: "acrylic paints with vibrant pigments",
    slug: "acrylic-paints-with-vibrant-pigments",
  },
  {
    name: "professional aerosol paints for art",
    slug: "professional-aerosol-paints-for-art",
  },
  {
    name: "best oil painting sets",
    slug: "best-oil-painting-sets",
  },
  {
    name: "watercolour paints with rich colours",
    slug: "watercolour-paints-with-rich-colours",
  },
  {
    name: "acrylic painting kits for beginners",
    slug: "acrylic-painting-kits-for-beginners",
  },
  {
    name: "aerosol paints for canvas",
    slug: "aerosol-paints-for-canvas",
  },
  {
    name: "gouache paints for detailed work",
    slug: "gouache-paints-for-detailed-work",
  },
  {
    name: "best spray paint",
    slug: "best-spray-paint",
  },
  {
    name: "oil painting kits online",
    slug: "oil-painting-kits-online",
  },
  {
    name: "artist acrylic paints for layering",
    slug: "artist-acrylic-paints-for-layering",
  },
  {
    name: "best oil paints for professionals",
    slug: "best-oil-paints-for-professionals",
  },
  {
    name: "gouache paints for illustration projects",
    slug: "gouache-paints-for-illustration-projects",
  },
  {
    name: "vibrant aerosol paints for art",
    slug: "vibrant-aerosol-paints-for-art",
  },
  {
    name: "best watercolours for beginners",
    slug: "best-watercolours-for-beginners",
  },
  {
    name: "oil painting supplies near me",
    slug: "oil-painting-supplies-near-me",
  },
  {
    name: "gouache painting supplies for artists",
    slug: "gouache-painting-supplies-for-artists",
  },
  {
    name: "top-quality acrylic paints online",
    slug: "top-quality-acrylic-paints-online",
  },
  {
    name: "best aerosol spray paints",
    slug: "best-aerosol-spray-paints",
  },
  {
    name: "watercolour paint sets for artists",
    slug: "watercolour-paint-sets-for-artists",
  },
  {
    name: "affordable oil painting kits",
    slug: "affordable-oil-painting-kits",
  },
  {
    name: "professional gouache paints online",
    slug: "professional-gouache-paints-online",
  },
  {
    name: "acrylic paints for art students",
    slug: "acrylic-paints-for-art-students",
  },
  {
    name: "best acrylic paints for canvas",
    slug: "best-acrylic-paints-for-canvas",
  },
  {
    name: "aerosol spray paints for walls",
    slug: "aerosol-spray-paints-for-walls",
  },
  {
    name: "high-quality watercolour paints",
    slug: "high-quality-watercolour-paints",
  },
  {
    name: "oil paints for advanced artists",
    slug: "oil-paints-for-advanced-artists",
  },
  {
    name: "professional artist acrylic paints",
    slug: "professional-artist-acrylic-paints",
  },
  {
    name: "gouache paints for professional artists",
    slug: "gouache-paints-for-professional-artists",
  },
  {
    name: "top-rated watercolour painting sets",
    slug: "top-rated-watercolour-painting-sets",
  },
  {
    name: "aerosol paints for professional murals",
    slug: "aerosol-paints-for-professional-murals",
  },
  {
    name: "affordable watercolour paints for beginners",
    slug: "affordable-watercolour-paints-for-beginners",
  },
  {
    name: "professional-grade acrylic painting supplies",
    slug: "professional-grade-acrylic-painting-supplies",
  },
  {
    name: "oil paints for realistic portraits",
    slug: "oil-paints-for-realistic-portraits",
  },
  {
    name: "best gouache painting kits",
    slug: "best-gouache-painting-kits",
  },
  {
    name: "vibrant acrylic paints for layering",
    slug: "vibrant-acrylic-paints-for-layering",
  },
  {
    name: "watercolour painting sets for students",
    slug: "watercolour-painting-sets-for-students",
  },
  {
    name: "aerosol paints with matte finish",
    slug: "aerosol-paints-with-matte-finish",
  },
  {
    name: "oil painting kits for beginners",
    slug: "oil-painting-kits-for-beginners",
  },
  {
    name: "professional watercolour paints online",
    slug: "professional-watercolour-paints-online",
  },
  {
    name: "gouache paints with rich pigments",
    slug: "gouache-paints-with-rich-pigments",
  },
  {
    name: "acrylic paints for mixed media projects",
    slug: "acrylic-paints-for-mixed-media-projects",
  },
  {
    name: "best oil paints for portraits",
    slug: "best-oil-paints-for-portraits",
  },
  {
    name: "artist aerosol paints for urban art",
    slug: "artist-aerosol-paints-for-urban-art",
  },
  {
    name: "oil painting supplies",
    slug: "oil-painting-supplies",
  },
  {
    name: "acrylic painting supplies",
    slug: "acrylic-painting-supplies",
  },
  {
    name: "oil painting supplies for professionals",
    slug: "oil-painting-supplies-for-professionals",
  },
  {
    name: "top-rated acrylic painting kits",
    slug: "top-rated-acrylic-painting-kits",
  },
  {
    name: "aerosol paints with glossy finish",
    slug: "aerosol-paints-with-glossy-finish",
  },
  {
    name: "best gouache paints for layering",
    slug: "best-gouache-paints-for-layering",
  },
  {
    name: "professional watercolour sets online",
    slug: "professional-watercolour-sets-online",
  },
  {
    name: "acrylic painting supplies for professionals",
    slug: "acrylic-painting-supplies-for-professionals",
  },
  {
    name: "oil paints with high pigment content",
    slug: "oil-paints-with-high-pigment-content",
  },
  {
    name: "best aerosol paints for canvas",
    slug: "best-aerosol-paints-for-canvas",
  },
  {
    name: "gouache paints with smooth finish",
    slug: "gouache-paints-with-smooth-finish",
  },
  {
    name: "watercolour painting supplies near me",
    slug: "watercolour-painting-supplies-near-me",
  },
  {
    name: "oil painting kits for professionals",
    slug: "oil-painting-kits-for-professionals",
  },
  {
    name: "affordable acrylic painting kits",
    slug: "affordable-acrylic-painting-kits",
  },
  {
    name: "professional aerosol spray paints",
    slug: "professional-aerosol-spray-paints",
  },
  {
    name: "watercolour paints for professional artists",
    slug: "watercolour-paints-for-professional-artists",
  },
  {
    name: "gouache painting supplies",
    slug: "gouache-painting-supplies",
  },
  {
    name: "acrylic paints for bold colours",
    slug: "acrylic-paints-for-bold-colours",
  },
  {
    name: "best watercolour painting kits",
    slug: "best-watercolour-painting-kits",
  },
  {
    name: "best watercolour paint",
    slug: "best-watercolour-paint",
  },
  {
    name: "best acrylic paint",
    slug: "best-acrylic-paint",
  },
  {
    name: "vibrant oil paints for detailed artwork",
    slug: "vibrant-oil-paints-for-detailed-artwork",
  },
  {
    name: "watercolour paints for landscapes",
    slug: "watercolour-paints-for-landscapes",
  },
  {
    name: "acrylic paints for abstract art",
    slug: "acrylic-paints-for-abstract-art",
  },
  {
    name: "aerosol paints for street artists",
    slug: "aerosol-paints-for-street-artists",
  },
];

/**
 * Obtiene una palabra de forma aleatoria del array de palabras.
 * @returns {Object} Un objeto con el nombre y slug de una palabra aleatoria.
 */
function getRandomWord() {
  const randomIndex = Math.floor(Math.random() * words.length);
  return words[randomIndex];
}

/**
 * Obtiene el slug de una palabra aleatoria.
 * @returns {String} El slug de una palabra aleatoria.
 */
function getRandomWordSlug() {
  const randomWord = getRandomWord();
  return randomWord.slug;
}

/**
 * Obtiene el nombre de una palabra aleatoria.
 * @returns {String} El nombre de una palabra aleatoria.
 */
function getRandomWordName() {
  const randomWord = getRandomWord();
  return randomWord.name;
}

// Hacer las funciones accesibles globalmente
window.getRandomWord = getRandomWord;
window.getRandomWordSlug = getRandomWordSlug;
window.getRandomWordName = getRandomWordName;
